
// import React, { useEffect, useState, useRef } from "react";
// import { PhoneInput } from "react-international-phone";
// import "react-international-phone/style.css";
// import "../Register Styles/animate.min.css";
// import "../Register Styles/aos.min.css";
// import "../Register Styles/bootstrap.min.css";
// import "../Register Styles/cursor.min.css";
// import "../Register Styles/custom.min.css";
// import "../Register Styles/magnific-popup.min.css";
// import "../Register Styles/odometer.min.css";
// import "../Register Styles/style.css";
// import "../Register Styles/swiper-bundle.min.css";
// import { useNavigate, useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify'; // Import toast

// // Import images
// import logo from "../assets/images/site_logo/logo.webp";
// import flowerShape from "../assets/images/shapes/shape_flower_1.svg";
// import footerShape from "../assets/images/shapes/shape_ico_hero_section_bottom.svg";
// import {  checkUsernameApi, 
//     checkEmailApi, 
//     checkMobileApi, 
//     checkUserCodeApi, 
//     checkPlacementPositionApi,
//     sendEmailOtpApi,
//     verifyEmailOtpApi,
//     registerApi  } from "../Services/Operations/ProductAPI";


// const Registration = () => {
//   const location = useLocation();
//   const pendingFormDataRef = useRef(null);
//   const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     accountName: "",
//     email: "",
//     sponsorId: "",
//     placementId: "",
//     position: "Left"
//   });

//   const [phone, setPhone] = useState("");
//   const [phoneCountryData, setPhoneCountryData] = useState({
//     dialCode: "91",
//     countryCode: "in",
//     countryName: "India",
//     fullNumber: "",
//     nationalNumber: ""
//   });

//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [recaptchaToken, setRecaptchaToken] = useState("");
//   const [validationErrors, setValidationErrors] = useState({});
//   const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
//   const [pendingFormData, setPendingFormData] = useState(null);
//   const [validationMessages, setValidationMessages] = useState({});
//   const [sponsorInfo, setSponsorInfo] = useState(null);
//   const [placementInfo, setPlacementInfo] = useState(null);
//   const [positionAvailability, setPositionAvailability] = useState(null);
//   const [isValidating, setIsValidating] = useState({
//     accountName: false,
//     email: false,
//     mobileNumber: false,
//     sponsorId: false,
//     placementId: false
//   });
//   const [isCheckingPosition, setIsCheckingPosition] = useState(false);
//   const otpRefs = useRef([...Array(6)].map(() => React.createRef()));
//   const recaptchaRef = useRef(null);

//   const debounceTimers = useRef({
//     accountName: null,
//     email: null,
//     mobileNumber: null,
//     sponsorId: null,
//     placementId: null
//   });

//   useEffect(() => {
//     const parseQueryParams = () => {
//       const queryParams = new URLSearchParams(location.search);
//       const placementCode = queryParams.get('placement_code');
//       const sponsorCode = queryParams.get('sponsor_code');
//       const position = queryParams.get('position');

//       console.log('Query params:', {
//         sponsorCode,
//         placementCode,
//         position,
//         fullSearch: location.search
//       });

//       if (sponsorCode) {
//         console.log('URL contains sponsor_code:', sponsorCode);
//         setFormData(prev => ({
//           ...prev,
//           sponsorId: sponsorCode
//         }));
//         setTimeout(() => {
//           if (sponsorCode.length >= 10) {
//             validateSponsor(sponsorCode);
//           }
//         }, 100);
//       }

//       if (placementCode) {
//         console.log('URL contains placement_code:', placementCode);
//         setFormData(prev => ({
//           ...prev,
//           placementId: placementCode
//         }));
//         setTimeout(() => {
//           if (placementCode.length >= 10) {
//             validatePlacement(placementCode);
//           }
//         }, 100);
//       }

//       if (position) {
//         console.log('URL contains position:', position);
//         const formattedPosition = position.toLowerCase() === 'left' ? 'Left' : 'Right';
//         setFormData(prev => ({
//           ...prev,
//           position: formattedPosition
//         }));
//         if (placementCode && placementCode.length >= 10) {
//           setTimeout(() => {
//             checkPositionAvailability(placementCode, formattedPosition);
//           }, 200);
//         }
//       }
//     };

//     parseQueryParams();
//   }, [location.search]);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 2000);

//     if (!recaptchaLoaded) {
//       console.log('📝 Page loaded, initiating reCAPTCHA...');
//       loadRecaptchaScript();
//     } else {
//       console.log('ℹ️ reCAPTCHA already loaded, re-initializing...');
//       initializeRecaptcha();
//     }

//     return () => {
//       clearTimeout(timer);
//       if (window.onRecaptchaLoadCallback) {
//         window.onRecaptchaLoadCallback = null;
//       }
//     };
//   }, []);

//   const loadRecaptchaScript = () => {
//     if (document.querySelector('script[src*="recaptcha"]')) {
//       console.log('ℹ️ reCAPTCHA script already loading/loaded');
//       if (window.grecaptcha && window.grecaptcha.render) {
//         setRecaptchaLoaded(true);
//         setTimeout(initializeRecaptcha, 500);
//       }
//       return;
//     }

//     console.log('📥 Loading reCAPTCHA script...');
//     const script = document.createElement('script');
//     script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
//     script.async = true;
//     script.defer = true;
    
//     script.onload = () => {
//       console.log('✅ reCAPTCHA script loaded');
//       setRecaptchaLoaded(true);
      
//       let attempts = 0;
//       const maxAttempts = 20;
      
//       const checkReady = setInterval(() => {
//         attempts++;
//         if (window.grecaptcha && window.grecaptcha.render) {
//           clearInterval(checkReady);
//           console.log('✅ grecaptcha.render available, initializing widget...');
//           setTimeout(initializeRecaptcha, 100);
//         } else if (attempts >= maxAttempts) {
//           clearInterval(checkReady);
//           console.error('❌ grecaptcha.render not available after waiting');
//           toast.error('Security verification failed to initialize. Please refresh.');
//           setRecaptchaLoaded(false);
//           setIsRecaptchaReady(false);
//         }
//       }, 250);
//     };
    
//     script.onerror = (error) => {
//       console.error('❌ Failed to load reCAPTCHA script:', error);
//       toast.error('Failed to load security verification. Please check your internet connection and refresh the page.');
//       setRecaptchaLoaded(false);
//       setIsRecaptchaReady(false);
//     };
    
//     document.body.appendChild(script);
//   };

//   const initializeRecaptcha = () => {
//     console.log('🔄 Initializing reCAPTCHA widget...');
    
//     if (!window.grecaptcha || !window.grecaptcha.render) {
//       console.error('❌ grecaptcha.render not available yet');
//       setIsRecaptchaReady(false);
//       return;
//     }

//     if (!recaptchaRef.current) {
//       console.error('❌ recaptchaRef.current is null');
//       setIsRecaptchaReady(false);
//       return;
//     }

//     const existingWidgetId = recaptchaRef.current.getAttribute('data-widget-id');
//     if (existingWidgetId && existingWidgetId !== 'null') {
//       console.log('ℹ️ reCAPTCHA widget already exists with ID:', existingWidgetId);
//       setIsRecaptchaReady(true);
//       return;
//     }

//     try {
//       console.log('✅ Creating new reCAPTCHA widget...');
      
//       const widgetId = window.grecaptcha.render(recaptchaRef.current, {
//         sitekey: '6Ld08hwsAAAAANC-Zywq87embbXedv98UPR_2D62',
//         size: 'invisible',
//         badge: 'bottomright',
//         callback: (token) => {
//           console.log('✅ reCAPTCHA token received (first 20 chars):', token.substring(0, 20) + '...');
//           setRecaptchaToken(token);
          
//           if (pendingFormDataRef.current) {
//             console.log('📤 Processing pending form data with token...');
//             handleSendOtp(pendingFormDataRef.current);
//             pendingFormDataRef.current = null;
//           }
//         },
//         'expired-callback': () => {
//           console.log('⚠️ reCAPTCHA token expired');
//           setRecaptchaToken('');
//           toast.warning('Security verification expired. Please try again.');
//           setIsRecaptchaReady(false);
//           resetRecaptcha();
//         },
//         'error-callback': () => {
//           console.error('❌ reCAPTCHA error callback triggered');
//           toast.error('Security verification error. Please refresh the page and try again.');
//           setIsRecaptchaReady(false);
//           setIsSubmitting(false);
//         }
//       });
      
//       console.log('✅ reCAPTCHA widget created with ID:', widgetId);
//       recaptchaRef.current.setAttribute('data-widget-id', widgetId);
//       setIsRecaptchaReady(true);
      
//     } catch (error) {
//       console.error('❌ Error creating reCAPTCHA widget:', error);
//       toast.error('Failed to initialize security verification. Please refresh the page.');
//       setIsRecaptchaReady(false);
//       setPendingFormData(null);
//       pendingFormDataRef.current = null;
//     }
//   };

//   useEffect(() => {
//     return () => {
//       if (window.grecaptcha && recaptchaRef.current) {
//         const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//         if (widgetId && widgetId !== 'null') {
//           try {
//             window.grecaptcha.reset(parseInt(widgetId));
//           } catch (e) {
//             console.log('Cleanup: reCAPTCHA already cleaned');
//           }
//         }
//       }
//     };
//   }, []);

//   const debounce = (func, delay, fieldName) => {
//     return (...args) => {
//       if (debounceTimers.current[fieldName]) {
//         clearTimeout(debounceTimers.current[fieldName]);
//       }

//       debounceTimers.current[fieldName] = setTimeout(() => {
//         func(...args);
//       }, delay);
//     };
//   };

// // const handlePhoneChange = (phoneNumber, phoneData) => {
// //   console.log("phoneNumber : ", phoneNumber);
// //   console.log("country data : ", phoneData);

// //   const dialCode = phoneData?.dialCode?.toString() || "91";
// //   const countryCode = phoneData?.iso2?.toLowerCase() || "in";
// //   const countryName = phoneData?.name || "India";

// //   console.log("dialCode:", dialCode);
// //   console.log("countryCode:", countryCode);
// //   console.log("countryName:", countryName);

// //   // Store the full formatted phone number (with spaces)
// //   setPhone(phoneNumber || "");

// //   let nationalNumber = "";

// //   if (phoneNumber) {
// //     // Remove all non-digit characters for processing
// //     const digitsOnly = phoneNumber.replace(/\D/g, "");
// //     console.log("digitsOnly:", digitsOnly);
    
// //     // Check if it's only the dial code (like +371 without actual number)
// //     const dialCodePattern = new RegExp(`^\\+?\\s*${dialCode}\\s*$`);
// //     const isOnlyDialCode = dialCodePattern.test(phoneNumber.trim());
// //     console.log("isOnlyDialCode:", isOnlyDialCode);

// //     if (isOnlyDialCode) {
// //       nationalNumber = "";
// //       console.log("Only dial code present");
// //     } else if (digitsOnly.startsWith(dialCode) && digitsOnly.length > dialCode.length) {
// //       nationalNumber = digitsOnly.substring(dialCode.length);
// //       console.log("Removed dialCode, nationalNumber:", nationalNumber);
// //     } else if (!digitsOnly.startsWith(dialCode)) {
// //       nationalNumber = digitsOnly;
// //       console.log("Doesn't start with dialCode, using as national number:", nationalNumber);
// //     } else {
// //       nationalNumber = "";
// //       console.log("Edge case");
// //     }
// //   } else {
// //     nationalNumber = "";
// //     console.log("No phone number");
// //   }

// //   console.log("nationalNumber : ", nationalNumber);

// //   // Update phone country data
// //   setPhoneCountryData({
// //     dialCode,
// //     countryCode,
// //     countryName,
// //     nationalNumber: nationalNumber,
// //     fullFormattedNumber: phoneNumber || "" // Store the formatted number with spaces
// //   });

// //   // Clear validation errors and messages
// //   if (validationErrors.mobileNumber) {
// //     setValidationErrors(prev => {
// //       const newErrors = { ...prev };
// //       delete newErrors.mobileNumber;
// //       return newErrors;
// //     });
// //   }

// //   if (validationMessages.mobileNumber) {
// //     setValidationMessages(prev => {
// //       const newMessages = { ...prev };
// //       delete newMessages.mobileNumber;
// //       return newMessages;
// //     });
// //   }

// //   // Validate mobile number if we have a national number
// //   if (nationalNumber && nationalNumber.length > 0) {
// //     const requiredDigits = countryCode === 'in' ? 10 : 8;
    
// //     if (nationalNumber.length >= requiredDigits) {
// //       console.log(`✅ Valid ${countryName} number (${nationalNumber.length} digits), calling API`);
// //       setIsValidating(prev => ({ ...prev, mobileNumber: true }));
// //       validateMobile(nationalNumber, countryName, `+${dialCode}`);
// //     } else if (nationalNumber.length > 0 && nationalNumber.length < requiredDigits) {
// //       console.log(`❌ ${countryName} number too short: ${nationalNumber.length} digits (need ${requiredDigits})`);
// //       setValidationErrors(prev => ({
// //         ...prev,
// //         mobileNumber: `Mobile number must be at least ${requiredDigits} digits`
// //       }));
// //       setIsValidating(prev => ({ ...prev, mobileNumber: false }));
// //     } else {
// //       setIsValidating(prev => ({ ...prev, mobileNumber: false }));
// //     }
// //   } else {
// //     setIsValidating(prev => ({ ...prev, mobileNumber: false }));
// //   }
// // };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'firstName' || name === 'lastName') {
//       const nameRegex = /^[A-Za-z\s\-']*$/;
//       if (!nameRegex.test(value) && value !== '') {
//         return;
//       }
//     }

//     if (name === 'accountName') {
//       const accountNameRegex = /^[A-Za-z0-9_]*$/;
//       if (!accountNameRegex.test(value) && value !== '') {
//         return;
//       }
//     }

//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));

//     if (validationErrors[name]) {
//       setValidationErrors(prev => {
//         const newErrors = { ...prev };
//         delete newErrors[name];
//         return newErrors;
//       });
//     }

//     if (validationMessages[name]) {
//       setValidationMessages(prev => {
//         const newMessages = { ...prev };
//         delete newMessages[name];
//         return newMessages;
//       });
//     }

//     if (name === 'sponsorId' && value.trim().length === 0) {
//       setSponsorInfo(null);
//     }
//     if (name === 'placementId' && value.trim().length === 0) {
//       setPlacementInfo(null);
//       setPositionAvailability(null);
//     }

//     switch (name) {
//       case 'firstName':
//         if (value.length > 0) {
//           if (value.length < 3) {
//             setValidationErrors(prev => ({
//               ...prev,
//               firstName: 'First name must be at least 3 characters'
//             }));
//           } else if (value.length > 25) {
//             setValidationErrors(prev => ({
//               ...prev,
//               firstName: 'First name cannot exceed 25 characters'
//             }));
//           } else {
//             setValidationErrors(prev => {
//               const newErrors = { ...prev };
//               delete newErrors.firstName;
//               return newErrors;
//             });
//           }
//         }
//         break;
//       case 'lastName':
//         if (value.length > 0) {
//           if (value.length < 3) {
//             setValidationErrors(prev => ({
//               ...prev,
//               lastName: 'Last name must be at least 3 characters'
//             }));
//           } else if (value.length > 25) {
//             setValidationErrors(prev => ({
//               ...prev,
//               lastName: 'Last name cannot exceed 25 characters'
//             }));
//           } else {
//             setValidationErrors(prev => {
//               const newErrors = { ...prev };
//               delete newErrors.lastName;
//               return newErrors;
//             });
//           }
//         }
//         break;
//       case 'accountName':
//         if (value.length > 0) {
//           if (value.length < 6) {
//             setValidationErrors(prev => ({
//               ...prev,
//               accountName: 'Account name must be at least 6 characters'
//             }));
//             setIsValidating(prev => ({ ...prev, accountName: false }));
//           } else if (value.length > 25) {
//             setValidationErrors(prev => ({
//               ...prev,
//               accountName: 'Account name cannot exceed 25 characters'
//             }));
//             setIsValidating(prev => ({ ...prev, accountName: false }));
//           } else {
//             setIsValidating(prev => ({ ...prev, accountName: true }));
//             debounce(() => validateUsername(value), 500, 'accountName')();
//           }
//         } else {
//           setValidationErrors(prev => {
//             const newErrors = { ...prev };
//             delete newErrors.accountName;
//             return newErrors;
//           });
//           setIsValidating(prev => ({ ...prev, accountName: false }));
//         }
//         break;
//       case 'email':
//         if (value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
//           setIsValidating(prev => ({ ...prev, email: true }));
//           debounce(() => validateEmail(value), 500, 'email')();
//         } else if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
//           setValidationErrors(prev => ({
//             ...prev,
//             email: 'Please enter a valid email address'
//           }));
//           setIsValidating(prev => ({ ...prev, email: false }));
//         }
//         break;
//       case 'sponsorId':
//         if (value.trim().length === 10) {
//           setIsValidating(prev => ({ ...prev, sponsorId: true }));
//           debounce(() => validateSponsor(value), 500, 'sponsorId')();
//         } else if (value.trim().length > 0 && value.trim().length !== 10) {
//           setValidationErrors(prev => ({
//             ...prev,
//             sponsorId: 'Sponsor ID must be exactly 10 characters'
//           }));
//           setValidationMessages(prev => {
//             const newMessages = { ...prev };
//             delete newMessages.sponsorId;
//             return newMessages;
//           });
//           setSponsorInfo(null);
//           setIsValidating(prev => ({ ...prev, sponsorId: false }));
//         } else if (value.trim().length === 0) {
//           setValidationErrors(prev => {
//             const newErrors = { ...prev };
//             delete newErrors.sponsorId;
//             return newErrors;
//           });
//           setIsValidating(prev => ({ ...prev, sponsorId: false }));
//         }
//         break;
//       case 'placementId':
//         if (value.trim().length === 10) {
//           setIsValidating(prev => ({ ...prev, placementId: true }));
//           debounce(() => {
//             validatePlacement(value);
//             checkPositionAvailability(value, formData.position);
//           }, 500, 'placementId')();
//         } else if (value.trim().length > 0 && value.trim().length !== 10) {
//           setValidationErrors(prev => ({
//             ...prev,
//             placementId: 'Placement ID must be exactly 10 characters'
//           }));
//           setValidationMessages(prev => {
//             const newMessages = { ...prev };
//             delete newMessages.placementId;
//             return newMessages;
//           });
//           setPlacementInfo(null);
//           setPositionAvailability(null);
//           setIsValidating(prev => ({ ...prev, placementId: false }));
//         } else if (value.trim().length === 0) {
//           setValidationErrors(prev => {
//             const newErrors = { ...prev };
//             delete newErrors.placementId;
//             return newErrors;
//           });
//           setPlacementInfo(null);
//           setPositionAvailability(null);
//           setIsValidating(prev => ({ ...prev, placementId: false }));
//         }
//         break;
//     }
//   };

//   const handlePositionChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({
//       ...prevState,
//       [name]: value
//     }));

//     if (formData.placementId && formData.placementId.trim().length === 10) {
//       checkPositionAvailability(formData.placementId, value);
//     }
//   };

//   // const checkPositionAvailability = async (placementId, position) => {
//   //   if (!placementId || placementId.length !== 10 || !position) {
//   //     setPositionAvailability(null);
//   //     return;
//   //   }

//   //   try {
//   //     setIsCheckingPosition(true);
//   //     const result = await checkPlacementPosition(placementId, position);
//   //     if (result.status) {
//   //       setPositionAvailability({
//   //         available: true,
//   //         message: `Position: ${position} is available`
//   //       });
//   //       setValidationErrors(prev => {
//   //         const newErrors = { ...prev };
//   //         delete newErrors.position;
//   //         return newErrors;
//   //       });
//   //     } else {
//   //       setPositionAvailability({
//   //         available: false,
//   //         message: result.message || `Position: ${position} is not available`
//   //       });
//   //       setValidationErrors(prev => ({
//   //         ...prev,
//   //         position: result.message || `Position ${position} is not available`
//   //       }));
//   //     }
//   //   } catch (error) {
//   //     console.error('Position availability check error:', error);
//   //     setPositionAvailability(null);
//   //   } finally {
//   //     setIsCheckingPosition(false);
//   //   }
//   // };

//   // const validateUsername = async (accountName) => {
//   //   if (!accountName || accountName.length < 6 || accountName.length > 25) return;

//   //   try {
//   //     const result = await checkUsername(accountName);
//   //     if (!result.status) {
//   //       setValidationErrors(prev => ({
//   //         ...prev,
//   //         accountName: result.message || 'Account name already taken'
//   //       }));
//   //       setValidationMessages(prev => ({
//   //         ...prev,
//   //         accountName: result.message
//   //       }));
//   //     } else {
//   //       setValidationErrors(prev => {
//   //         const newErrors = { ...prev };
//   //         delete newErrors.accountName;
//   //         return newErrors;
//   //       });
//   //       setValidationMessages(prev => ({
//   //         ...prev,
//   //         accountName: result.message || 'Username is available'
//   //       }));
//   //     }
//   //   } catch (error) {
//   //     console.error('Username validation error:', error);
//   //     setValidationMessages(prev => ({
//   //       ...prev,
//   //       accountName: 'Error checking username availability'
//   //     }));
//   //   } finally {
//   //     setIsValidating(prev => ({ ...prev, accountName: false }));
//   //   }
//   // };

//   const checkPositionAvailability = async (placementId, position) => {
//     if (!placementId || placementId.length !== 10 || !position) {
//         setPositionAvailability(null);
//         return;
//     }

//     try {
//         setIsCheckingPosition(true);
//         const result = await checkPlacementPositionApi(placementId, position);
//         if (result.status) {
//             setPositionAvailability({
//                 available: true,
//                 message: `Position: ${position} is available`
//             });
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors.position;
//                 return newErrors;
//             });
//         } else {
//             setPositionAvailability({
//                 available: false,
//                 message: result.message || `Position: ${position} is not available`
//             });
//             setValidationErrors(prev => ({
//                 ...prev,
//                 position: result.message || `Position ${position} is not available`
//             }));
//         }
//     } catch (error) {
//         console.error('Position availability check error:', error);
//         setPositionAvailability(null);
//     } finally {
//         setIsCheckingPosition(false);
//     }
// };

//   const validateUsername = async (accountName) => {
//     if (!accountName || accountName.length < 6 || accountName.length > 25) return;

//     try {
//         const result = await checkUsernameApi(accountName);
//         if (!result.status) {
//             setValidationErrors(prev => ({
//                 ...prev,
//                 accountName: result.message || 'Account name already taken'
//             }));
//             setValidationMessages(prev => ({
//                 ...prev,
//                 accountName: result.message
//             }));
//         } else {
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors.accountName;
//                 return newErrors;
//             });
//             setValidationMessages(prev => ({
//                 ...prev,
//                 accountName: result.message || 'Username is available'
//             }));
//         }
//     } catch (error) {
//         console.error('Username validation error:', error);
//         setValidationMessages(prev => ({
//             ...prev,
//             accountName: 'Error checking username availability'
//         }));
//     } finally {
//         setIsValidating(prev => ({ ...prev, accountName: false }));
//     }
// };

//   // const validateEmail = async (email) => {
//   //   if (!email) return;

//   //   try {
//   //     const result = await checkEmail(email);
//   //     if (!result.status) {
//   //       setValidationErrors(prev => ({
//   //         ...prev,
//   //         email: result.message || 'Email already registered'
//   //       }));
//   //       setValidationMessages(prev => ({
//   //         ...prev,
//   //         email: result.message
//   //       }));
//   //     } else {
//   //       setValidationErrors(prev => {
//   //         const newErrors = { ...prev };
//   //         delete newErrors.email;
//   //         return newErrors;
//   //       });
//   //       setValidationMessages(prev => ({
//   //         ...prev,
//   //         email: result.message || 'Email is available'
//   //       }));
//   //     }
//   //   } catch (error) {
//   //     console.error('Email validation error:', error);
//   //     setValidationMessages(prev => ({
//   //       ...prev,
//   //       email: 'Error checking email availability'
//   //     }));
//   //   } finally {
//   //     setIsValidating(prev => ({ ...prev, email: false }));
//   //   }
//   // };

//   // const validateMobile = async (nationalNumber, countryName, countryCode) => {
//   //   if (!nationalNumber || nationalNumber.length < 10) return;

//   //   try {
//   //     console.log('validateMobile called with:', {
//   //       nationalNumber,
//   //       countryName,
//   //       countryCode,
//   //       phoneCountryData: phoneCountryData
//   //     });

//   //     const result = await checkMobile(
//   //       phoneCountryData.nationalNumber,
//   //       phoneCountryData.countryName,
//   //       `+${phoneCountryData.dialCode}`
//   //     );

//   //     if (!result.status) {
//   //       setValidationErrors(prev => ({
//   //         ...prev,
//   //         mobileNumber: result.message || 'Mobile number already registered'
//   //       }));
//   //       setValidationMessages(prev => ({
//   //         ...prev,
//   //         mobileNumber: result.message
//   //       }));
//   //     } else {
//   //       setValidationErrors(prev => {
//   //         const newErrors = { ...prev };
//   //         delete newErrors.mobileNumber;
//   //         return newErrors;
//   //       });
//   //       setValidationMessages(prev => ({
//   //         ...prev,
//   //         mobileNumber: result.message || 'Mobile number is available'
//   //       }));
//   //     }
//   //   } catch (error) {
//   //     console.error('Mobile validation error:', error);
//   //     setValidationMessages(prev => ({
//   //       ...prev,
//   //       mobileNumber: 'Error checking mobile number availability'
//   //     }));
//   //   } finally {
//   //     setIsValidating(prev => ({ ...prev, mobileNumber: false }));
//   //   }
//   // };

//   const validateEmail = async (email) => {
//     if (!email) return;

//     try {
//         const result = await checkEmailApi(email);
//         if (!result.status) {
//             setValidationErrors(prev => ({
//                 ...prev,
//                 email: result.message || 'Email already registered'
//             }));
//             setValidationMessages(prev => ({
//                 ...prev,
//                 email: result.message
//             }));
//         } else {
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors.email;
//                 return newErrors;
//             });
//             setValidationMessages(prev => ({
//                 ...prev,
//                 email: result.message || 'Email is available'
//             }));
//         }
//     } catch (error) {
//         console.error('Email validation error:', error);
//         setValidationMessages(prev => ({
//             ...prev,
//             email: 'Error checking email availability'
//         }));
//     } finally {
//         setIsValidating(prev => ({ ...prev, email: false }));
//     }
// };

//   // const validateSponsor = async (sponsorId) => {
//   //   if (!sponsorId || sponsorId.length !== 10) return;

//   //   try {
//   //     const result = await checkUserCode(sponsorId);
//   //     if (!result.status) {
//   //       setValidationErrors(prev => ({
//   //         ...prev,
//   //         sponsorId: result.message || 'Invalid sponsor ID'
//   //       }));
//   //       setSponsorInfo(null);
//   //     } else {
//   //       setValidationErrors(prev => {
//   //         const newErrors = { ...prev };
//   //         delete newErrors.sponsorId;
//   //         return newErrors;
//   //       });
//   //       if (result.data && result.data.account_name) {
//   //         setSponsorInfo({
//   //           accountName: result.data.account_name
//   //         });
//   //       } else {
//   //         setSponsorInfo(null);
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error('Sponsor validation error:', error);
//   //     setSponsorInfo(null);
//   //   } finally {
//   //     setIsValidating(prev => ({ ...prev, sponsorId: false }));
//   //   }
//   // };

//   const validateSponsor = async (sponsorId) => {
//     if (!sponsorId || sponsorId.length !== 10) return;

//     try {
//         const result = await checkUserCodeApi(sponsorId);
//         if (!result.status) {
//             setValidationErrors(prev => ({
//                 ...prev,
//                 sponsorId: result.message || 'Invalid sponsor ID'
//             }));
//             setSponsorInfo(null);
//         } else {
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors.sponsorId;
//                 return newErrors;
//             });
//             if (result.data && result.data.account_name) {
//                 setSponsorInfo({
//                     accountName: result.data.account_name
//                 });
//             } else {
//                 setSponsorInfo(null);
//             }
//         }
//     } catch (error) {
//         console.error('Sponsor validation error:', error);
//         setSponsorInfo(null);
//     } finally {
//         setIsValidating(prev => ({ ...prev, sponsorId: false }));
//     }
// };

//   const validatePlacement = async (placementId) => {
//     if (!placementId || placementId.length !== 10) return;

//     try {
//       const result = await checkUserCode(placementId);
//       if (!result.status) {
//         setValidationErrors(prev => ({
//           ...prev,
//           placementId: result.message || 'Invalid placement ID'
//         }));
//         setPlacementInfo(null);
//       } else {
//         setValidationErrors(prev => {
//           const newErrors = { ...prev };
//           delete newErrors.placementId;
//           return newErrors;
//         });
//         if (result.data && result.data.account_name) {
//           setPlacementInfo({
//             accountName: result.data.account_name
//           });
//         } else {
//           setPlacementInfo(null);
//         }
//       }
//     } catch (error) {
//       console.error('Placement validation error:', error);
//       setPlacementInfo(null);
//     } finally {
//       setIsValidating(prev => ({ ...prev, placementId: false }));
//     }
//   };

//   const resetRecaptcha = () => {
//     console.log('🔄 Resetting reCAPTCHA...');
    
//     if (window.grecaptcha && recaptchaRef.current) {
//       const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
//       if (widgetId && widgetId !== 'null') {
//         try {
//           window.grecaptcha.reset(parseInt(widgetId));
//           console.log('✅ reCAPTCHA reset successfully');
//         } catch (error) {
//           console.log('⚠️ Could not reset reCAPTCHA:', error);
//         }
//       }
//     }
    
//     setRecaptchaToken("");
//     setPendingFormData(null);
//     pendingFormDataRef.current = null;
    
//     setTimeout(() => {
//       if (window.grecaptcha && window.grecaptcha.render) {
//         initializeRecaptcha();
//       }
//     }, 500);
//   };

//   const handleOtpChange = (index, value) => {
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     if (value && index < 5) {
//       otpRefs.current[index + 1].current.focus();
//     }

//     if (index === 5 && value && newOtp.every(digit => digit !== "")) {
//       const fullOtp = newOtp.join('');
//       verifyOtp(fullOtp);
//     }
//   };

//   const handleOtpKeyDown = (index, e) => {
//     if (e.key === 'Backspace') {
//       if (!otp[index] && index > 0) {
//         const newOtp = [...otp];
//         newOtp[index - 1] = "";
//         setOtp(newOtp);
//         otpRefs.current[index - 1].current.focus();
//       }
//     }
//   };

//   const createFormUrlEncoded = (data) => {
//     const formBody = [];
//     for (const property in data) {
//       const encodedKey = encodeURIComponent(property);
//       const encodedValue = encodeURIComponent(data[property]);
//       formBody.push(encodedKey + "=" + encodedValue);
//     }
//     return formBody.join("&");
//   };

//   const checkUsername = async (accountName) => {
//     try {
//       const formBody = createFormUrlEncoded({
//         account_name: accountName
//       });

//       const response = await fetch('https://global.thewillowquantum.com/api/check-username', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: formBody
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Check username error:', error);
//       return { status: false, message: 'Error checking username' };
//     }
//   };

//   const checkEmail = async (email) => {
//     try {
//       const formBody = createFormUrlEncoded({
//         email: email
//       });

//       const response = await fetch('https://global.thewillowquantum.com/api/check-email', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: formBody
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Check email error:', error);
//       return { status: false, message: 'Error checking email' };
//     }
//   };

// const checkMobile = async (nationalNumber, countryName, countryCode) => {
//   try {
//     console.log('checkMobile API call with:', {
//       mobile_number: nationalNumber,
//       country_name: countryName,
//       country_code: countryCode
//     });

//     const formBody = createFormUrlEncoded({
//       mobile_number: nationalNumber || "",
//       country_name: countryName || "",
//       country_code: countryCode || ""
//     });

//     console.log('Form body for check-mobile:', formBody);

//     const response = await fetch('https://global.thewillowquantum.com/api/check-mobile', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       body: formBody
//     });

//     const result = await response.json();
//     console.log('checkMobile API response:', result);
//     return result;

//   } catch (error) {
//     console.error('Check mobile error:', error);
//     return { status: false, message: 'Error checking mobile number' };
//   }
// };

// // const validateMobile = async (nationalNumber, countryName, countryCode) => {
// //   if (!nationalNumber) return;

// //   try {
// //     console.log('validateMobile called with:', {
// //       nationalNumber,
// //       countryName,
// //       countryCode
// //     });

// //     const result = await checkMobile(nationalNumber, countryName, countryCode);

// //     if (!result.status) {
// //       setValidationErrors(prev => ({
// //         ...prev,
// //         mobileNumber: result.message || 'Mobile number already registered'
// //       }));
// //       setValidationMessages(prev => ({
// //         ...prev,
// //         mobileNumber: result.message
// //       }));
// //     } else {
// //       setValidationErrors(prev => {
// //         const newErrors = { ...prev };
// //         delete newErrors.mobileNumber;
// //         return newErrors;
// //       });
// //       setValidationMessages(prev => ({
// //         ...prev,
// //         mobileNumber: result.message || 'Mobile number is available'
// //       }));
// //     }
// //   } catch (error) {
// //     console.error('Mobile validation error:', error);
// //     setValidationMessages(prev => ({
// //       ...prev,
// //       mobileNumber: 'Error checking mobile number availability'
// //     }));
// //   } finally {
// //     setIsValidating(prev => ({ ...prev, mobileNumber: false }));
// //   }
// // };

// const validateMobile = async (nationalNumber, countryName, countryCode) => {
//     if (!nationalNumber) return;

//     try {
//         const result = await checkMobileApi(nationalNumber, countryName, countryCode);

//         if (!result.status) {
//             setValidationErrors(prev => ({
//                 ...prev,
//                 mobileNumber: result.message || 'Mobile number already registered'
//             }));
//             setValidationMessages(prev => ({
//                 ...prev,
//                 mobileNumber: result.message
//             }));
//         } else {
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors.mobileNumber;
//                 return newErrors;
//             });
//             setValidationMessages(prev => ({
//                 ...prev,
//                 mobileNumber: result.message || 'Mobile number is available'
//             }));
//         }
//     } catch (error) {
//         console.error('Mobile validation error:', error);
//         setValidationMessages(prev => ({
//             ...prev,
//             mobileNumber: 'Error checking mobile number availability'
//         }));
//     } finally {
//         setIsValidating(prev => ({ ...prev, mobileNumber: false }));
//     }
// };

// const handlePhoneChange = (phoneNumber, phoneData) => {
//   console.log("phoneNumber : ", phoneNumber);
//   console.log("country data : ", phoneData);

//   // FIX: Extract from phoneData.country object (not root level)
//   const countryInfo = phoneData?.country || {};
//   const dialCode = countryInfo.dialCode || "91";
//   const countryCode = countryInfo.iso2?.toLowerCase() || "in";
//   const countryName = countryInfo.name || "India";

//   console.log("dialCode:", dialCode);
//   console.log("countryCode:", countryCode);
//   console.log("countryName:", countryName);

//   // Store the full formatted phone number (with spaces/hyphens for display)
//   setPhone(phoneNumber || "");

//   let nationalNumber = "";

//   if (phoneNumber) {
//     // Remove ALL non-digit characters including hyphens, spaces, parentheses, etc.
//     const digitsOnly = phoneNumber.replace(/\D/g, "");
//     console.log("digitsOnly:", digitsOnly);
    
//     // Check if it's only the dial code (like +371 without actual number)
//     const dialCodePattern = new RegExp(`^\\+?\\s*${dialCode}\\s*$`);
//     const isOnlyDialCode = dialCodePattern.test(phoneNumber.trim());
//     console.log("isOnlyDialCode:", isOnlyDialCode);

//     if (isOnlyDialCode) {
//       nationalNumber = "";
//       console.log("Only dial code present");
//     } else if (digitsOnly.startsWith(dialCode) && digitsOnly.length > dialCode.length) {
//       nationalNumber = digitsOnly.substring(dialCode.length);
//       console.log("Removed dialCode, nationalNumber:", nationalNumber);
//     } else if (!digitsOnly.startsWith(dialCode)) {
//       nationalNumber = digitsOnly;
//       console.log("Doesn't start with dialCode, using as national number:", nationalNumber);
//     } else {
//       nationalNumber = "";
//       console.log("Edge case");
//     }
//   } else {
//     nationalNumber = "";
//     console.log("No phone number");
//   }

//   console.log("nationalNumber (clean digits only):", nationalNumber);

//   // Update phone country data
//   setPhoneCountryData({
//     dialCode,
//     countryCode,
//     countryName,
//     nationalNumber: nationalNumber,
//     fullFormattedNumber: phoneNumber || "" // Store the formatted number with spaces
//   });

//   // Clear validation errors and messages
//   if (validationErrors.mobileNumber) {
//     setValidationErrors(prev => {
//       const newErrors = { ...prev };
//       delete newErrors.mobileNumber;
//       return newErrors;
//     });
//   }

//   if (validationMessages.mobileNumber) {
//     setValidationMessages(prev => {
//       const newMessages = { ...prev };
//       delete newMessages.mobileNumber;
//       return newMessages;
//     });
//   }

//   // Validate mobile number if we have a national number
//   if (nationalNumber && nationalNumber.length > 0) {
//     const requiredDigits = countryCode === 'in' ? 10 : 8;
    
//     if (nationalNumber.length >= requiredDigits) {
//       console.log(`✅ Valid ${countryName} number (${nationalNumber.length} digits), calling API`);
//       setIsValidating(prev => ({ ...prev, mobileNumber: true }));
      
//       // Use the dynamically extracted values
//       validateMobile(nationalNumber, countryName, `+${dialCode}`);
//     } else if (nationalNumber.length > 0 && nationalNumber.length < requiredDigits) {
//       console.log(`❌ ${countryName} number too short: ${nationalNumber.length} digits (need ${requiredDigits})`);
//       setValidationErrors(prev => ({
//         ...prev,
//         mobileNumber: `Mobile number must be at least ${requiredDigits} digits for ${countryName}`
//       }));
//       setIsValidating(prev => ({ ...prev, mobileNumber: false }));
//     } else {
//       setIsValidating(prev => ({ ...prev, mobileNumber: false }));
//     }
//   } else {
//     setIsValidating(prev => ({ ...prev, mobileNumber: false }));
//   }
// };

//   const checkUserCode = async (userCode) => {
//     try {
//       const formBody = createFormUrlEncoded({
//         user_code: userCode
//       });

//       const response = await fetch('https://global.thewillowquantum.com/api/check-user-code', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: formBody
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Check user code error:', error);
//       return { status: false, message: 'Error checking user code' };
//     }
//   };

//   const checkPlacementPosition = async (userCode, position) => {
//     try {
//       const formBody = createFormUrlEncoded({
//         user_code: userCode,
//         position: position
//       });

//       const response = await fetch('https://global.thewillowquantum.com/api/check-placement-position', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: formBody
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Check placement position error:', error);
//       return { status: false, message: 'Error checking placement position' };
//     }
//   };

//   const validateAllFields = async () => {
//   const errors = {};

//   if (!formData.firstName || formData.firstName.length < 3) {
//     errors.firstName = 'First name must be at least 3 characters';
//   } else if (formData.firstName.length > 25) {
//     errors.firstName = 'First name cannot exceed 25 characters';
//   }

//   if (!formData.lastName || formData.lastName.length < 3) {
//     errors.lastName = 'Last name must be at least 3 characters';
//   } else if (formData.lastName.length > 25) {
//     errors.lastName = 'Last name cannot exceed 25 characters';
//   }

//   if (!formData.accountName) {
//     errors.accountName = 'Account name is required';
//   } else if (formData.accountName.length < 6) {
//     errors.accountName = 'Account name must be at least 6 characters';
//   } else if (formData.accountName.length > 25) {
//     errors.accountName = 'Account name cannot exceed 25 characters';
//   }

//   if (!phoneCountryData.nationalNumber || phoneCountryData.nationalNumber.length === 0) {
//     errors.mobileNumber = 'Mobile number is required';
//   } else if (phoneCountryData.countryCode === 'in') {
//     if (phoneCountryData.nationalNumber.length !== 10) {
//       errors.mobileNumber = 'Mobile number must be 10 digits for India';
//     }
//   } else {
//     if (phoneCountryData.nationalNumber.length < 8) {
//       errors.mobileNumber = 'Mobile number must be at least 8 digits';
//     }
//   }

//   if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//     errors.email = 'Please enter a valid email address';
//   }

//   if (!formData.sponsorId || formData.sponsorId.length !== 10) {
//     errors.sponsorId = 'Sponsor ID must be exactly 10 characters';
//   }

//   if (!formData.placementId || formData.placementId.length !== 10) {
//     errors.placementId = 'Placement ID must be exactly 10 characters';
//   }

//   if (positionAvailability && !positionAvailability.available) {
//     errors.position = positionAvailability.message;
//   }

//   if (Object.keys(errors).length > 0) {
//     setValidationErrors(errors);
//     return false;
//   }

//   if (Object.keys(validationErrors).length > 0) {
//     return false;
//   }

//   return true;
// };

//   // const handleSendOtp = async (data) => {
//   //   try {
//   //     if (!data || !data.email) {
//   //       toast.error("Email data is missing. Please try again.");
//   //       setIsSubmitting(false);
//   //       resetRecaptcha();
//   //       return;
//   //     }

//   //     const fullName = `${data.firstName} ${data.lastName}`;

//   //     const formBody = createFormUrlEncoded({
//   //       email: data.email,
//   //       name: fullName
//   //     });

//   //     const response = await fetch("https://global.thewillowquantum.com/api/send-email-otp", {
//   //       method: "POST",
//   //       headers: {
//   //         'Content-Type': 'application/x-www-form-urlencoded',
//   //       },
//   //       body: formBody
//   //     });

//   //     const result = await response.json();

//   //     if (result.status) {
//   //       setCurrentStep(2);
//   //       toast.success("OTP has been sent to your email");
//   //     } else {
//   //       toast.error(result.message || "Failed to send OTP. Please try again.");
//   //     }
//   //   } catch (error) {
//   //     console.error("Send OTP error:", error);
//   //     toast.error("An error occurred while sending OTP. Please try again.");
//   //   } finally {
//   //     setIsSubmitting(false);
//   //     resetRecaptcha();
//   //   }
//   // };

//   const handleSendOtp = async (data) => {
//     try {
//         if (!data || !data.email) {
//             toast.error("Email data is missing. Please try again.");
//             setIsSubmitting(false);
//             resetRecaptcha();
//             return;
//         }

//         const fullName = `${data.firstName} ${data.lastName}`;

//         const result = await sendEmailOtpApi(data.email, fullName);

//         if (result.status) {
//             setCurrentStep(2);
//             toast.success("OTP has been sent to your email");
//         } else {
//             toast.error(result.message || "Failed to send OTP. Please try again.");
//         }
//     } catch (error) {
//         console.error("Send OTP error:", error);
//         toast.error("An error occurred while sending OTP. Please try again.");
//     } finally {
//         setIsSubmitting(false);
//         resetRecaptcha();
//     }
// };

//   // const verifyOtp = async (otpValue) => {
//   //   try {
//   //     setIsSubmitting(true);

//   //     const formBody = createFormUrlEncoded({
//   //       email: formData.email,
//   //       otp: otpValue
//   //     });

//   //     const response = await fetch('https://global.thewillowquantum.com/api/verify-email-otp', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/x-www-form-urlencoded',
//   //       },
//   //       body: formBody
//   //     });

//   //     const result = await response.json();

//   //     if (result.status) {
//   //       await handleRegistration();
//   //     } else {
//   //       toast.error(result.message || 'Invalid OTP. Please try again.');
//   //       setIsSubmitting(false);
//   //       setOtp(["", "", "", "", "", ""]);
//   //       if (otpRefs.current[0].current) {
//   //         otpRefs.current[0].current.focus();
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error('OTP verification error:', error);
//   //     toast.error('An error occurred during OTP verification. Please try again.');
//   //     setIsSubmitting(false);
//   //   }
//   // };

//   const verifyOtp = async (otpValue) => {
//     try {
//         setIsSubmitting(true);

//         const result = await verifyEmailOtpApi(formData.email, otpValue);

//         if (result.status) {
//             await handleRegistration();
//         } else {
//             toast.error(result.message || 'Invalid OTP. Please try again.');
//             setIsSubmitting(false);
//             setOtp(["", "", "", "", "", ""]);
//             if (otpRefs.current[0].current) {
//                 otpRefs.current[0].current.focus();
//             }
//         }
//     } catch (error) {
//         console.error('OTP verification error:', error);
//         toast.error('An error occurred during OTP verification. Please try again.');
//         setIsSubmitting(false);
//     }
// };

//   // const handleRegistration = async () => {
//   //   try {
//   //     const formBody = createFormUrlEncoded({
//   //       first_name: formData.firstName,
//   //       last_name: formData.lastName,
//   //       account_name: formData.accountName,
//   //       mobile_number: phoneCountryData.nationalNumber,
//   //       email: formData.email,
//   //       sponsor_code: formData.sponsorId,
//   //       placement_code: formData.placementId,
//   //       position: formData.position,
//   //       country_name: phoneCountryData.countryName,
//   //       country_code: `+${phoneCountryData.dialCode}`
//   //     });

//   //     console.log('Sending registration data:', {
//   //       mobile_number: phoneCountryData.nationalNumber,
//   //       country_name: phoneCountryData.countryName,
//   //       country_code: `+${phoneCountryData.dialCode}`,
//   //       full_form_data: {
//   //         first_name: formData.firstName,
//   //         last_name: formData.lastName,
//   //         account_name: formData.accountName,
//   //         email: formData.email,
//   //         sponsor_code: formData.sponsorId,
//   //         placement_code: formData.placementId,
//   //         position: formData.position
//   //       }
//   //     });

//   //     const response = await fetch('https://global.thewillowquantum.com/api/register', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/x-www-form-urlencoded',
//   //       },
//   //       body: formBody
//   //     });

//   //     const result = await response.json();

//   //     if (result.status) {
//   //       toast.success('Registration completed successfully! Login credentials have been sent to your email.');
//   //       navigate('/signin');
//   //     } else {
//   //       toast.error(result.message || 'Registration failed. Please try again.');
//   //       setIsSubmitting(false);
//   //     }
//   //   } catch (error) {
//   //     console.error('Registration error:', error);
//   //     toast.error('An error occurred during registration. Please try again.');
//   //     setIsSubmitting(false);
//   //   }
//   // };

//   const handleRegistration = async () => {
//     try {
//         const registrationData = {
//             first_name: formData.firstName,
//             last_name: formData.lastName,
//             account_name: formData.accountName,
//             mobile_number: phoneCountryData.nationalNumber,
//             email: formData.email,
//             sponsor_code: formData.sponsorId,
//             placement_code: formData.placementId,
//             position: formData.position,
//             country_name: phoneCountryData.countryName,
//             country_code: `+${phoneCountryData.dialCode}`
//         };

//         console.log('Sending registration data:', registrationData);

//         const result = await registerApi(registrationData);

//         if (result.status) {
//             toast.success('Registration completed successfully! Login credentials have been sent to your email.');
//             navigate('/signin');
//         } else {
//             toast.error(result.message || 'Registration failed. Please try again.');
//             setIsSubmitting(false);
//         }
//     } catch (error) {
//         console.error('Registration error:', error);
//         toast.error('An error occurred during registration. Please try again.');
//         setIsSubmitting(false);
//     }
// };

//   const executeRecaptcha = (data) => {
//     console.log('🔐 Executing reCAPTCHA...');
    
//     pendingFormDataRef.current = data;
    
//     if (!window.grecaptcha) {
//       console.error("❌ grecaptcha not loaded");
//       toast.error("Security verification is still loading. Please wait and try again.");
//       setIsSubmitting(false);
//       return;
//     }
    
//     if (!recaptchaRef.current) {
//       console.error("❌ recaptchaRef.current is null");
//       toast.error("Security verification error. Please refresh the page.");
//       setIsSubmitting(false);
//       return;
//     }
    
//     const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
    
//     if (!widgetId || widgetId === 'null') {
//       console.error("❌ No valid widget ID found. Initializing...");
      
//       initializeRecaptcha();
      
//       setTimeout(() => {
//         const newWidgetId = recaptchaRef.current?.getAttribute('data-widget-id');
//         if (newWidgetId && newWidgetId !== 'null') {
//           console.log('🔄 Retrying with new widget ID:', newWidgetId);
//           try {
//             window.grecaptcha.execute(parseInt(newWidgetId));
//           } catch (error) {
//             console.error('Error executing reCAPTCHA after retry:', error);
//             setIsSubmitting(false);
//             toast.error('Security verification failed. Please try again.');
//           }
//         } else {
//           console.error('Failed to create widget');
//           setIsSubmitting(false);
//           toast.error('Security verification failed to initialize. Please refresh.');
//         }
//       }, 1000);
//     } else {
//       try {
//         console.log('✅ Executing widget with ID:', widgetId);
//         window.grecaptcha.execute(parseInt(widgetId));
//       } catch (error) {
//         console.error('❌ Error executing reCAPTCHA:', error);
//         setIsSubmitting(false);
//         toast.error('Security verification failed. Please refresh and try again.');
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (isSubmitting) {
//       console.log('⚠️ Already submitting, ignoring duplicate submission');
//       return;
//     }

//     if (currentStep === 1) {
//       console.log('📝 Step 1: Validating form...');
//       setIsSubmitting(true);
      
//       const isValid = await validateAllFields();
      
//       if (!isValid) {
//         console.log('❌ Validation failed');
//         setIsSubmitting(false);
//         return;
//       }

//       console.log('✅ Validation passed');

//       if (!isRecaptchaReady) {
//         console.log('⏳ reCAPTCHA not ready yet');
        
//         toast.info("Initializing security verification... Please wait a moment.");
        
//         if (!recaptchaLoaded) {
//           loadRecaptchaScript();
//         } else if (!recaptchaRef.current.hasAttribute('data-widget-id')) {
//           initializeRecaptcha();
//         }
        
//         setTimeout(() => {
//           if (isRecaptchaReady) {
//             executeRecaptcha(formData);
//           } else {
//             setIsSubmitting(false);
//             toast.warning("Security verification is taking longer than expected. Please try submitting again.");
//           }
//         }, 1500);
        
//         return;
//       }

//       console.log('🔐 Executing reCAPTCHA...');
//       executeRecaptcha(formData);
      
//     } else {
//       console.log('📝 Step 2: Verifying OTP...');
//       const fullOtp = otp.join('');
//       if (fullOtp.length !== 6) {
//         toast.error('Please enter a valid 6-digit OTP');
//         return;
//       }
//       verifyOtp(fullOtp);
//     }
//   };

//   // const resendOtp = async () => {
//   //   try {
//   //     const fullName = `${formData.firstName} ${formData.lastName}`;

//   //     const formBody = createFormUrlEncoded({
//   //       email: formData.email,
//   //       name: fullName
//   //     });

//   //     const response = await fetch('https://global.thewillowquantum.com/api/send-email-otp', {
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/x-www-form-urlencoded',
//   //       },
//   //       body: formBody
//   //     });

//   //     const result = await response.json();

//   //     if (result.status) {
//   //       toast.success('OTP has been resent to your email.');
//   //       setOtp(["", "", "", "", "", ""]);
//   //       if (otpRefs.current[0].current) {
//   //         otpRefs.current[0].current.focus();
//   //       }
//   //     } else {
//   //       toast.error(result.message || 'Failed to resend OTP. Please try again.');
//   //     }
//   //   } catch (error) {
//   //     console.error('Resend OTP error:', error);
//   //     toast.error('Failed to resend OTP. Please try again.');
//   //   }
//   // };

// const resendOtp = async () => {
//     try {
//         const fullName = `${formData.firstName} ${formData.lastName}`;

//         const result = await sendEmailOtpApi(formData.email, fullName);

//         if (result.status) {
//             toast.success('OTP has been resent to your email.');
//             setOtp(["", "", "", "", "", ""]);
//             if (otpRefs.current[0].current) {
//                 otpRefs.current[0].current.focus();
//             }
//         } else {
//             toast.error(result.message || 'Failed to resend OTP. Please try again.');
//         }
//     } catch (error) {
//         console.error('Resend OTP error:', error);
//         toast.error('Failed to resend OTP. Please try again.');
//     }
// };
  
//   return (
//     <div className="page_wrapper index_ico">
//       <div className="backtotop">
//         <a href="#" className="scroll">
//           <i className="fa-solid fa-arrow-up"></i>
//         </a>
//       </div>

//       <header className="site_header">
//         <div className="nav_wrapper">
//           <div className="container">
//             <div className="row align-items-center">
//               <div className="col-lg-3 col-5 d-flex align-items-center">
//                 <div className="site_logo">
//                   <a className="site_link" href="/">
//                     <img loading="lazy" src={logo} alt="Logo" />
//                   </a>
//                 </div>
//               </div>
//               <div className="col-lg-6 col-2">
//                 <nav className="main_menu navbar-box navbar-expand-lg">
//                   <div className="main_menu_inner collapse navbar-collapse justify-content-center" id="main_menu_dropdown">
//                     <ul className="main_menu_list unordered_list text-uppercase">
//                       <li className="active">
//                         <a className="nav-link" href="#.">
//                           <span className="nav_link_label" data-text="Home">Home</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#.">
//                           <span className="nav_link_label" data-text="About Us">About Us</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#.">
//                           <span className="nav_link_label" data-text="Services">Services</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link scrollspy_btn" href="#.">
//                           <span className="nav_link_label" data-text="Metamask">Metamask</span>
//                         </a>
//                       </li>
//                       <li>
//                         <a className="nav-link" href="#.">
//                           <span className="nav_link_label" data-text="Contact Us">Contact Us</span>
//                         </a>
//                       </li>
//                     </ul>
//                   </div>
//                 </nav>
//               </div>
//               <div className="col-lg-3 col-5">
//                 <ul className="btns_group unordered_list p-0 justify-content-end">
//                   <li className="d-lg-none">
//                     <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
//                       <i className="far fa-bars"></i>
//                     </button>
//                   </li>
//                   <li>
//                     <a className="ico_btn_outline" href="/signin">
//                       <span className="btn_icon">
//                         <i className="fa-solid fa-user"></i>
//                       </span>
//                       <span className="btn_label">Login</span>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="page_content">
//         <section className="register_section section_decoration">
//           <div className="container">
//             <div className="row justify-content-center">
//               <div className="col-lg-5 position-relative">
//                 <form className="register_form" onSubmit={handleSubmit}>
//                   <h1 className="heading_text text-center">
//                     {currentStep === 1 ? 'Create Willow Account' : 'Verify Email'}
//                   </h1>
//                   <p className="text-center">
//                     {currentStep === 1 ? 'Enter your details to register with Willow Quantum' : 'Enter OTP sent to your email'}
//                   </p>

//                   {currentStep === 1 ? (
//                     <>
//                       <div className="row">
//                         <div className="col-md-6">
//                           <div className="form-group">
//                             <label className="input_title" htmlFor="input_firstName">
//                               First Name<sup>*</sup>
//                             </label>
//                             <input
//                               id="input_firstName"
//                               className={`form-control ${validationErrors.firstName ? 'is-invalid' : ''}`}
//                               type="text"
//                               name="firstName"
//                               value={formData.firstName}
//                               onChange={handleInputChange}
//                               placeholder="Enter First Name (3-25 letters)"
//                               maxLength="25"
//                               required
//                               disabled={isSubmitting}
//                               autoComplete="off"
//                             />
//                             {validationErrors.firstName && (
//                               <div className="invalid-feedback d-block">{validationErrors.firstName}</div>
//                             )}
//                           </div>
//                         </div>
//                         <div className="col-md-6">
//                           <div className="form-group">
//                             <label className="input_title" htmlFor="input_lastName">
//                               Last Name<sup>*</sup>
//                             </label>
//                             <input
//                               id="input_lastName"
//                               className={`form-control ${validationErrors.lastName ? 'is-invalid' : ''}`}
//                               type="text"
//                               name="lastName"
//                               value={formData.lastName}
//                               onChange={handleInputChange}
//                               placeholder="Enter Last Name (3-25 letters)"
//                               maxLength="25"
//                               required
//                               disabled={isSubmitting}
//                               autoComplete="off"
//                             />
//                             {validationErrors.lastName && (
//                               <div className="invalid-feedback d-block">{validationErrors.lastName}</div>
//                             )}
//                           </div>
//                         </div>
//                       </div>

//                       <div className="form-group">
//                         <label className="input_title" htmlFor="input_accountName">
//                           Account Name<sup>*</sup>
//                         </label>
//                         <input
//                           id="input_accountName"
//                           className={`form-control ${validationErrors.accountName ? 'is-invalid' : ''} ${validationMessages.accountName && !validationErrors.accountName ? 'is-valid' : ''}`}
//                           type="text"
//                           name="accountName"
//                           value={formData.accountName}
//                           onChange={handleInputChange}
//                           placeholder="Enter Account Name (6-25 characters)"
//                           maxLength="25"
//                           required
//                           disabled={isSubmitting}
//                           autoComplete="off"
//                         />
//                         {validationErrors.accountName && (
//                           <div className="invalid-feedback d-block">{validationErrors.accountName}</div>
//                         )}
//                         {validationMessages.accountName && !validationErrors.accountName && (
//                           <div className="valid-feedback d-block">{validationMessages.accountName}</div>
//                         )}
//                         {isValidating.accountName && (
//                           <small className="form-text text-muted">Checking availability...</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className="input_title" htmlFor="input_mobileNumber">
//                           Mobile Number<sup>*</sup>
//                         </label>
//                         <div className="phone-input-container">
//                           <PhoneInput
//                             defaultCountry="in"
//                             value={phone}
//                             onChange={(phone, country) => handlePhoneChange(phone, country)}
//                             placeholder="Enter phone number"
//                              disableFormatting={true}
//       // Optional: Add these props for more control:
//       forceDialCode={false}
//                             inputStyle={{
//                               backgroundColor: "#fff",
//                               color: "#333",
//                               width: "100%",
//                               padding: "12px",
//                               border: validationErrors.mobileNumber ? "1px solid #dc3545" : "1px solid #ced4da",
//                               borderRadius: "0.375rem",
//                             }}
//                             countrySelectorStyleProps={{
//                               buttonStyle: {
//                                 backgroundColor: "#fff",
//                                 color: "#333",
//                                 border: validationErrors.mobileNumber ? "1px solid #dc3545" : "1px solid #ced4da",
//                                 borderRight: "none",
//                                 borderRadius: "0.375rem 0 0 0.375rem",
//                               },
//                               dropdownStyle: {
//                                 backgroundColor: "#fff",
//                                 color: "#333",
//                               },
//                             }}
//                             disabled={isSubmitting}
//                           />
//                         </div>
//                         {validationErrors.mobileNumber && (
//                           <div className="invalid-feedback d-block">{validationErrors.mobileNumber}</div>
//                         )}
//                         {validationMessages.mobileNumber && !validationErrors.mobileNumber && (
//                           <div className="valid-feedback d-block">{validationMessages.mobileNumber}</div>
//                         )}
//                         {isValidating.mobileNumber && (
//                           <small className="form-text text-muted">Checking availability...</small>
//                         )}

//                       </div>

//                       <div className="form-group">
//                         <label className="input_title" htmlFor="input_email">
//                           Email<sup>*</sup>
//                         </label>
//                         <input
//                           id="input_email"
//                           className={`form-control ${validationErrors.email ? 'is-invalid' : ''} ${validationMessages.email && !validationErrors.email ? 'is-valid' : ''}`}
//                           type="email"
//                           name="email"
//                           value={formData.email}
//                           onChange={handleInputChange}
//                           placeholder="Enter Email"
//                           required
//                           disabled={isSubmitting}
//                           autoComplete="off"
//                         />
//                         {validationErrors.email && (
//                           <div className="invalid-feedback d-block">{validationErrors.email}</div>
//                         )}
//                         {validationMessages.email && !validationErrors.email && (
//                           <div className="valid-feedback d-block">{validationMessages.email}</div>
//                         )}
//                         {isValidating.email && (
//                           <small className="form-text text-muted">Checking availability...</small>
//                         )}
//                       </div>

//                       <div className="row">
//                         <div className="col-md-6">
//                           <div className="form-group">
//                             <label className="input_title" htmlFor="input_sponsorId">
//                               Sponsor ID<sup>*</sup>
//                             </label>
//                             <input
//                               id="input_sponsorId"
//                               className={`form-control ${validationErrors.sponsorId ? 'is-invalid' : ''}`}
//                               type="text"
//                               name="sponsorId"
//                               value={formData.sponsorId}
//                               onChange={handleInputChange}
//                               placeholder="Sponsor ID"
//                               maxLength="25"
//                               required
//                               disabled={isSubmitting}
//                               readOnly={location.search.includes('sponsor_code')}
//                               autoComplete="off"
//                             />
//                             {validationErrors.sponsorId && (
//                               <div className="invalid-feedback d-block">{validationErrors.sponsorId}</div>
//                             )}
//                             {isValidating.sponsorId && (
//                               <small className="form-text text-muted">Checking sponsor ID...</small>
//                             )}
//                             {sponsorInfo && sponsorInfo.accountName && (
//                               <div className="sponsor-info mt-2 p-2 bg-light rounded">
//                                 <small className="text-success d-block">
//                                   Sponsor: {sponsorInfo.accountName}
//                                 </small>
//                               </div>
//                             )}

//                           </div>
//                         </div>
//                         <div className="col-md-6">
//                           <div className="form-group">
//                             <label className="input_title" htmlFor="input_placementId">
//                               Placement ID<sup>*</sup>
//                             </label>
//                             <input
//                               id="input_placementId"
//                               className={`form-control ${validationErrors.placementId ? 'is-invalid' : ''}`}
//                               type="text"
//                               name="placementId"
//                               value={formData.placementId}
//                               onChange={handleInputChange}
//                               placeholder="Placement ID"
//                               maxLength="10"
//                               required
//                               disabled={isSubmitting}
//                               readOnly={location.search.includes('placement_code')}
//                               autoComplete="off"
//                             />
//                             {validationErrors.placementId && (
//                               <div className="invalid-feedback d-block">{validationErrors.placementId}</div>
//                             )}
//                             {isValidating.placementId && (
//                               <small className="form-text text-muted">Checking placement ID...</small>
//                             )}
//                             {placementInfo && placementInfo.accountName && (
//                               <div className="placement-info mt-2 p-2 bg-light rounded">
//                                 <small className="text-success d-block">
//                                   {placementInfo.accountName}
//                                 </small>
//                               </div>
//                             )}

//                           </div>
//                         </div>
//                       </div>

//                       <div className="form-group">
//                         <label className="input_title" htmlFor="input_position">
//                           Position<sup>*</sup>
//                         </label>
//                         <div className="position-selector">
//                           <label className={`position-option ${formData.position === 'Left' ? 'active' : ''}`}>
//                             <input
//                               type="radio"
//                               name="position"
//                               value="Left"
//                               checked={formData.position === "Left"}
//                               onChange={handlePositionChange}
//                               disabled={isSubmitting || location.search.includes('position=')}
//                             />
//                             <span>Left</span>
//                           </label>
//                           <label className={`position-option ${formData.position === 'Right' ? 'active' : ''}`}>
//                             <input
//                               type="radio"
//                               name="position"
//                               value="Right"
//                               checked={formData.position === "Right"}
//                               onChange={handlePositionChange}
//                               disabled={isSubmitting || location.search.includes('position=')}
//                             />
//                             <span>Right</span>
//                           </label>
//                         </div>
//                         {isCheckingPosition && (
//                           <small className="form-text text-muted">Checking position availability...</small>
//                         )}
//                         {positionAvailability && !isCheckingPosition && (
//                           <div className={`position-status mt-2 p-2 rounded ${positionAvailability.available ? 'bg-light text-success' : 'bg-light text-danger'}`}>
//                             <small className="d-block">
//                               <strong>{positionAvailability.message}</strong>
//                             </small>
//                           </div>
//                         )}

//                       </div>

//                       <div ref={recaptchaRef} style={{ display: 'none' }} />
//                     </>
//                   ) : (
//                     <div className="form-group">
//                       <label className="input_title" htmlFor="input_otp">
//                         OTP Verification<sup>*</sup>
//                       </label>
//                       <div className="otp-container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                         {otp.map((digit, index) => (
//                           <input
//                             key={index}
//                             ref={otpRefs.current[index]}
//                             className={`otp-digit ${digit ? 'filled' : ''} ${isSubmitting ? 'disabled' : ''}`}
//                             type="text"
//                             value={digit}
//                             onChange={(e) => handleOtpChange(index, e.target.value)}
//                             onKeyDown={(e) => handleOtpKeyDown(index, e)}
//                             maxLength="1"
//                             disabled={isSubmitting}
//                             autoFocus={index === 0}
//                             inputMode="numeric"
//                             pattern="[0-9]*"
//                           />
//                         ))}
//                       </div>
//                       <p className="text-center mt-2">
//                         OTP sent to {formData.email}.
//                         <button
//                           type="button"
//                           className="btn btn-link p-0 ml-1"
//                           onClick={resendOtp}
//                           disabled={isSubmitting}
//                         >
//                           Resend OTP
//                         </button>
//                       </p>
//                     </div>
//                   )}

//                   <div className="row">
//                     <div className="col-md-6">
//                       <p className="forget_pass text-md-start mb-0">
//                         Already registered! <a href="/signin"><u>Login</u></a>
//                       </p>
//                     </div>
//                   </div>

//                   <button
//                     className="btn"
//                     type="submit"
//                     disabled={isSubmitting}
//                   >
//                     <span className="btn_label">
//                       {isSubmitting ? 'Processing...' :
//                         currentStep === 1 ? 'Send OTP' : 'Verify OTP'}
//                     </span>
//                     <span className="btn_icon">
//                       {isSubmitting ? (
//                         <div className="spinner-border spinner-border-sm" role="status">
//                           <span className="visually-hidden">Loading...</span>
//                         </div>
//                       ) : (
//                         <i className="fa-regular fa-arrow-up-right"></i>
//                       )}
//                     </span>
//                   </button>
//                 </form>

//                 <div className="decoration_item shape_flower">
//                   <img src={flowerShape} alt="Flower" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>

//       <footer className="ico_site_footer section_decoration section_shadow_top">
//         <div className="decoration_item shape_top">
//           <img src={footerShape} alt="Bottom Line Shape" />
//         </div>
//         <div className="container">
//           <ul className="pagelist_block unordered_list justify-content-center text-uppercase">
//             <li>
//               <a className="scrollspy_btn" href="#.">
//                 <span className="pagelist_label">Home</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#.">
//                 <span className="pagelist_label">About Us</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#.">
//                 <span className="pagelist_label">Services</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#.">
//                 <span className="pagelist_label">Metamask</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#.">
//                 <span className="pagelist_label">Team</span>
//               </a>
//             </li>
//             <li>
//               <a className="scrollspy_btn" href="#.">
//                 <span className="pagelist_label">Contact Us</span>
//               </a>
//             </li>
//           </ul>
//           <div className="middle_area">
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Join our social group</h3>
//               <ul className="social_block style_2 unordered_list justify-content-center">
//                 <li>
//                   <a href="#!">
//                     <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M12.1817 2.34636C10.5036 3.04236 7.14877 4.48456 2.11879 6.67146C1.30201 6.99576 0.873436 7.31296 0.834656 7.62286C0.768491 8.14806 1.42705 8.35476 2.32148 8.63456C2.44372 8.67336 2.57025 8.71206 2.69969 8.75516C3.58123 9.04066 4.76611 9.37506 5.38149 9.38796C5.9409 9.39946 6.56497 9.16986 7.25381 8.69916C11.9531 5.53206 14.379 3.93206 14.5314 3.89756C14.6393 3.87316 14.7888 3.84166 14.8894 3.93206C14.9901 4.02106 14.9801 4.19036 14.97 4.23626C14.9038 4.51326 12.3241 6.90826 10.9868 8.14806C10.5698 8.53416 10.2749 8.80826 10.2146 8.87136C10.0794 9.01056 9.94141 9.14396 9.80908 9.27176C8.98941 10.0581 8.37683 10.6494 9.84356 11.6137C10.5482 12.0772 11.1119 12.4604 11.6741 12.8421C12.2882 13.2597 12.9008 13.6758 13.6945 14.1953C13.8959 14.3273 14.0886 14.4636 14.2769 14.5971C14.9916 15.1065 15.6343 15.5628 16.4281 15.4911C16.8883 15.448 17.3656 15.0161 17.6072 13.726C18.1781 10.6752 19.3026 4.06836 19.5629 1.34476C19.5788 1.11856 19.5691 0.891358 19.5341 0.667358C19.5132 0.486458 19.425 0.320058 19.2868 0.201058C19.0812 0.0331581 18.7619 -0.002742 18.6182 0.000158001C17.9696 0.011558 16.9746 0.357458 12.1817 2.34636Z" />
//                     </svg>
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#!">
//                     <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M14.7876 14L9.31558 5.8405L9.32498 5.8482L14.2588 0H12.6101L8.59076 4.76L5.39902 0H1.07488L6.18362 7.6179L0.794922 14H2.44366L6.91214 8.7042L10.4635 14H14.7876ZM4.74576 1.2727L12.4234 12.7273H11.1168L3.43295 1.2727H4.74576Z" />
//                     </svg>
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#!">
//                     <i className="fa-brands fa-github" />
//                   </a>
//                 </li>
//               </ul>
//             </div>
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Subscribe to our newsletter</h3>
//               <form className="ico_newsletter_form" action="#">
//                 <input type="email" name="email" placeholder="Enter your email" />
//                 <button className="submit_btn" type="submit">Submit</button>
//               </form>
//             </div>
//             <div className="column">
//               <h3 className="footer_title text-uppercase">Let's coinpay great together.</h3>
//               <a className="ico_creative_btn" href="#!">
//                 <span className="btn_wrapper">
//                   <span className="btn_icon_left">
//                     <small className="dot_top" />
//                     <small className="dot_bottom" />
//                     <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
//                       <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
//                       <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
//                     </svg>
//                   </span>
//                   <span className="btn_label">Purchase a Token</span>
//                   <span className="btn_icon_right">
//                     <small className="dot_top" />
//                     <small className="dot_bottom" />
//                     <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
//                       <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
//                       <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
//                     </svg>
//                   </span>
//                 </span>
//               </a>
//             </div>
//           </div>
//           <div className="footer_bottom text-center">
//             <p className="copyright_text m-0 text-secondary">Copyright© 2025 Willow Quantum. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Registration;


import React, { useEffect, useState, useRef } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "../Register Styles/animate.min.css";
import "../Register Styles/aos.min.css";
import "../Register Styles/bootstrap.min.css";
import "../Register Styles/cursor.min.css";
import "../Register Styles/custom.min.css";
import "../Register Styles/magnific-popup.min.css";
import "../Register Styles/odometer.min.css";
import "../Register Styles/style.css";
import "../Register Styles/swiper-bundle.min.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify'; // Import toast

// Import images
import logo from "../assets/images/site_logo/logo.webp";
import flowerShape from "../assets/images/shapes/shape_flower_1.svg";
import footerShape from "../assets/images/shapes/shape_ico_hero_section_bottom.svg";
import {  checkUsernameApi, 
    checkEmailApi, 
    checkMobileApi, 
    checkUserCodeApi, 
    checkPlacementPositionApi,
    sendEmailOtpApi,
    verifyEmailOtpApi,
    registerApi  } from "../Services/Operations/ProductAPI";


const Registration = () => {
  const location = useLocation();
  const pendingFormDataRef = useRef(null);
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    accountName: "",
    email: "",
    sponsorId: "",
    placementId: "",
    position: "Left"
  });

  const [phone, setPhone] = useState("");
  const [phoneCountryData, setPhoneCountryData] = useState({
    dialCode: "91",
    countryCode: "in",
    countryName: "India",
    fullNumber: "",
    nationalNumber: ""
  });

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [validationMessages, setValidationMessages] = useState({});
  const [sponsorInfo, setSponsorInfo] = useState(null);
  const [placementInfo, setPlacementInfo] = useState(null);
  const [positionAvailability, setPositionAvailability] = useState(null);
  const [isValidating, setIsValidating] = useState({
    accountName: false,
    email: false,
    mobileNumber: false,
    sponsorId: false,
    placementId: false
  });
  const [isCheckingPosition, setIsCheckingPosition] = useState(false);
  const otpRefs = useRef([...Array(6)].map(() => React.createRef()));
  const recaptchaRef = useRef(null);

  const debounceTimers = useRef({
    accountName: null,
    email: null,
    mobileNumber: null,
    sponsorId: null,
    placementId: null
  });

  useEffect(() => {
  const parseQueryParams = () => {
  const queryParams = new URLSearchParams(location.search);
  const placementCode = queryParams.get('placement_code');
  const sponsorCode = queryParams.get('sponsor_code');
  const position = queryParams.get('position');

  console.log('Query params:', {
    sponsorCode,
    placementCode,
    position,
    fullSearch: location.search
  });

  if (sponsorCode) {
    console.log('URL contains sponsor_code:', sponsorCode);
    setFormData(prev => ({
      ...prev,
      sponsorId: sponsorCode
    }));
    setTimeout(() => {
      if (sponsorCode.length >= 10) {
        validateSponsor(sponsorCode);
      }
    }, 100);
  }

  if (placementCode) {
    console.log('URL contains placement_code:', placementCode);
    setFormData(prev => ({
      ...prev,
      placementId: placementCode
    }));
    setTimeout(() => {
      if (placementCode.length >= 10) {
        validatePlacement(placementCode);
      }
    }, 100);
  }

  if (position) {
    console.log('URL contains position:', position);
    // Convert to proper case (Left/Right)
    const formattedPosition = position.charAt(0).toUpperCase() + position.slice(1).toLowerCase();
    console.log('Formatted position:', formattedPosition);
    
    // Update form data with the position from URL
    setFormData(prev => ({
      ...prev,
      position: formattedPosition === 'Left' || formattedPosition === 'Right' 
        ? formattedPosition 
        : 'Left' // Default to Left if invalid
    }));
    
    // Also update the position availability
    if (placementCode && placementCode.length >= 10) {
      setTimeout(() => {
        checkPositionAvailability(placementCode, formattedPosition);
      }, 200);
    }
  }
};

    parseQueryParams();
  }, [location.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    if (!recaptchaLoaded) {
      console.log('📝 Page loaded, initiating reCAPTCHA...');
      loadRecaptchaScript();
    } else {
      console.log('ℹ️ reCAPTCHA already loaded, re-initializing...');
      initializeRecaptcha();
    }

    return () => {
      clearTimeout(timer);
      if (window.onRecaptchaLoadCallback) {
        window.onRecaptchaLoadCallback = null;
      }
    };
  }, []);

  const loadRecaptchaScript = () => {
    if (document.querySelector('script[src*="recaptcha"]')) {
      console.log('ℹ️ reCAPTCHA script already loading/loaded');
      if (window.grecaptcha && window.grecaptcha.render) {
        setRecaptchaLoaded(true);
        setTimeout(initializeRecaptcha, 500);
      }
      return;
    }

    console.log('📥 Loading reCAPTCHA script...');
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      console.log('✅ reCAPTCHA script loaded');
      setRecaptchaLoaded(true);
      
      let attempts = 0;
      const maxAttempts = 20;
      
      const checkReady = setInterval(() => {
        attempts++;
        if (window.grecaptcha && window.grecaptcha.render) {
          clearInterval(checkReady);
          console.log('✅ grecaptcha.render available, initializing widget...');
          setTimeout(initializeRecaptcha, 100);
        } else if (attempts >= maxAttempts) {
          clearInterval(checkReady);
          console.error('❌ grecaptcha.render not available after waiting');
          toast.error('Security verification failed to initialize. Please refresh.');
          setRecaptchaLoaded(false);
          setIsRecaptchaReady(false);
        }
      }, 250);
    };
    
    script.onerror = (error) => {
      console.error('❌ Failed to load reCAPTCHA script:', error);
      toast.error('Failed to load security verification. Please check your internet connection and refresh the page.');
      setRecaptchaLoaded(false);
      setIsRecaptchaReady(false);
    };
    
    document.body.appendChild(script);
  };

  const initializeRecaptcha = () => {
    console.log('🔄 Initializing reCAPTCHA widget...');
    
    if (!window.grecaptcha || !window.grecaptcha.render) {
      console.error('❌ grecaptcha.render not available yet');
      setIsRecaptchaReady(false);
      return;
    }

    if (!recaptchaRef.current) {
      console.error('❌ recaptchaRef.current is null');
      setIsRecaptchaReady(false);
      return;
    }

    const existingWidgetId = recaptchaRef.current.getAttribute('data-widget-id');
    if (existingWidgetId && existingWidgetId !== 'null') {
      console.log('ℹ️ reCAPTCHA widget already exists with ID:', existingWidgetId);
      setIsRecaptchaReady(true);
      return;
    }

    try {
      console.log('✅ Creating new reCAPTCHA widget...');
      
      const widgetId = window.grecaptcha.render(recaptchaRef.current, {
        sitekey: '6Ld08hwsAAAAANC-Zywq87embbXedv98UPR_2D62',
        size: 'invisible',
        badge: 'bottomright',
        callback: (token) => {
          console.log('✅ reCAPTCHA token received (first 20 chars):', token.substring(0, 20) + '...');
          setRecaptchaToken(token);
          
          if (pendingFormDataRef.current) {
            console.log('📤 Processing pending form data with token...');
            handleSendOtp(pendingFormDataRef.current);
            pendingFormDataRef.current = null;
          }
        },
        'expired-callback': () => {
          console.log('⚠️ reCAPTCHA token expired');
          setRecaptchaToken('');
          toast.warning('Security verification expired. Please try again.');
          setIsRecaptchaReady(false);
          resetRecaptcha();
        },
        'error-callback': () => {
          console.error('❌ reCAPTCHA error callback triggered');
          // toast.error('Security verification error. Please refresh the page and try again.');
          setIsRecaptchaReady(false);
          setIsSubmitting(false);
        }
      });
      
      console.log('✅ reCAPTCHA widget created with ID:', widgetId);
      recaptchaRef.current.setAttribute('data-widget-id', widgetId);
      setIsRecaptchaReady(true);
      
    } catch (error) {
      console.error('❌ Error creating reCAPTCHA widget:', error);
      toast.error('Failed to initialize security verification. Please refresh the page.');
      setIsRecaptchaReady(false);
      setPendingFormData(null);
      pendingFormDataRef.current = null;
    }
  };

  useEffect(() => {
    return () => {
      if (window.grecaptcha && recaptchaRef.current) {
        const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
        if (widgetId && widgetId !== 'null') {
          try {
            window.grecaptcha.reset(parseInt(widgetId));
          } catch (e) {
            console.log('Cleanup: reCAPTCHA already cleaned');
          }
        }
      }
    };
  }, []);

  const debounce = (func, delay, fieldName) => {
    return (...args) => {
      if (debounceTimers.current[fieldName]) {
        clearTimeout(debounceTimers.current[fieldName]);
      }

      debounceTimers.current[fieldName] = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'firstName' || name === 'lastName') {
      const nameRegex = /^[A-Za-z\s\-']*$/;
      if (!nameRegex.test(value) && value !== '') {
        return;
      }
    }

    if (name === 'accountName') {
      const accountNameRegex = /^[A-Za-z0-9_]*$/;
      if (!accountNameRegex.test(value) && value !== '') {
        return;
      }
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (validationErrors[name]) {
      setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    if (validationMessages[name]) {
      setValidationMessages(prev => {
        const newMessages = { ...prev };
        delete newMessages[name];
        return newMessages;
      });
    }

    if (name === 'sponsorId' && value.trim().length === 0) {
      setSponsorInfo(null);
    }
    if (name === 'placementId' && value.trim().length === 0) {
      setPlacementInfo(null);
      setPositionAvailability(null);
    }

    switch (name) {
      case 'firstName':
        if (value.length > 0) {
          if (value.length < 3) {
            setValidationErrors(prev => ({
              ...prev,
              firstName: 'First name must be at least 3 characters'
            }));
          } else if (value.length > 25) {
            setValidationErrors(prev => ({
              ...prev,
              firstName: 'First name cannot exceed 25 characters'
            }));
          } else {
            setValidationErrors(prev => {
              const newErrors = { ...prev };
              delete newErrors.firstName;
              return newErrors;
            });
          }
        }
        break;
      case 'lastName':
        if (value.length > 0) {
          if (value.length < 3) {
            setValidationErrors(prev => ({
              ...prev,
              lastName: 'Last name must be at least 3 characters'
            }));
          } else if (value.length > 25) {
            setValidationErrors(prev => ({
              ...prev,
              lastName: 'Last name cannot exceed 25 characters'
            }));
          } else {
            setValidationErrors(prev => {
              const newErrors = { ...prev };
              delete newErrors.lastName;
              return newErrors;
            });
          }
        }
        break;
      case 'accountName':
        if (value.length > 0) {
          if (value.length < 6) {
            setValidationErrors(prev => ({
              ...prev,
              accountName: 'Account name must be at least 6 characters'
            }));
            setIsValidating(prev => ({ ...prev, accountName: false }));
          } else if (value.length > 25) {
            setValidationErrors(prev => ({
              ...prev,
              accountName: 'Account name cannot exceed 25 characters'
            }));
            setIsValidating(prev => ({ ...prev, accountName: false }));
          } else {
            setIsValidating(prev => ({ ...prev, accountName: true }));
            debounce(() => validateUsername(value), 500, 'accountName')();
          }
        } else {
          setValidationErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors.accountName;
            return newErrors;
          });
          setIsValidating(prev => ({ ...prev, accountName: false }));
        }
        break;
      case 'email':
        if (value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          setIsValidating(prev => ({ ...prev, email: true }));
          debounce(() => validateEmail(value), 500, 'email')();
        } else if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          setValidationErrors(prev => ({
            ...prev,
            email: 'Please enter a valid email address'
          }));
          setIsValidating(prev => ({ ...prev, email: false }));
        }
        break;
      case 'sponsorId':
        if (value.trim().length === 10) {
          setIsValidating(prev => ({ ...prev, sponsorId: true }));
          debounce(() => validateSponsor(value), 500, 'sponsorId')();
        } else if (value.trim().length > 0 && value.trim().length !== 10) {
          setValidationErrors(prev => ({
            ...prev,
            sponsorId: 'Sponsor ID must be exactly 10 characters'
          }));
          setValidationMessages(prev => {
            const newMessages = { ...prev };
            delete newMessages.sponsorId;
            return newMessages;
          });
          setSponsorInfo(null);
          setIsValidating(prev => ({ ...prev, sponsorId: false }));
        } else if (value.trim().length === 0) {
          setValidationErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors.sponsorId;
            return newErrors;
          });
          setIsValidating(prev => ({ ...prev, sponsorId: false }));
        }
        break;
      case 'placementId':
        if (value.trim().length === 10) {
          setIsValidating(prev => ({ ...prev, placementId: true }));
          debounce(() => {
            validatePlacement(value);
            checkPositionAvailability(value, formData.position);
          }, 500, 'placementId')();
        } else if (value.trim().length > 0 && value.trim().length !== 10) {
          setValidationErrors(prev => ({
            ...prev,
            placementId: 'Placement ID must be exactly 10 characters'
          }));
          setValidationMessages(prev => {
            const newMessages = { ...prev };
            delete newMessages.placementId;
            return newMessages;
          });
          setPlacementInfo(null);
          setPositionAvailability(null);
          setIsValidating(prev => ({ ...prev, placementId: false }));
        } else if (value.trim().length === 0) {
          setValidationErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors.placementId;
            return newErrors;
          });
          setPlacementInfo(null);
          setPositionAvailability(null);
          setIsValidating(prev => ({ ...prev, placementId: false }));
        }
        break;
    }
  };

  const handlePositionChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (formData.placementId && formData.placementId.trim().length === 10) {
      checkPositionAvailability(formData.placementId, value);
    }
  };

  const checkPositionAvailability = async (placementId, position) => {
    if (!placementId || placementId.length !== 10 || !position) {
        setPositionAvailability(null);
        return;
    }

    try {
        setIsCheckingPosition(true);
        const result = await checkPlacementPositionApi(placementId, position);
        if (result.status) {
            setPositionAvailability({
                available: true,
                message: `Position: ${position} is available`
            });
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.position;
                return newErrors;
            });
        } else {
            setPositionAvailability({
                available: false,
                message: result.message || `Position: ${position} is not available`
            });
            setValidationErrors(prev => ({
                ...prev,
                position: result.message || `Position ${position} is not available`
            }));
        }
    } catch (error) {
        console.error('Position availability check error:', error);
        setPositionAvailability(null);
    } finally {
        setIsCheckingPosition(false);
    }
};

  const validateUsername = async (accountName) => {
    if (!accountName || accountName.length < 6 || accountName.length > 25) return;

    try {
        const result = await checkUsernameApi(accountName);
        if (!result.status) {
            setValidationErrors(prev => ({
                ...prev,
                accountName: result.message || 'Account name already taken'
            }));
            setValidationMessages(prev => ({
                ...prev,
                accountName: result.message
            }));
        } else {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.accountName;
                return newErrors;
            });
            setValidationMessages(prev => ({
                ...prev,
                accountName: result.message || 'Username is available'
            }));
        }
    } catch (error) {
        console.error('Username validation error:', error);
        setValidationMessages(prev => ({
            ...prev,
            accountName: 'Error checking username availability'
        }));
    } finally {
        setIsValidating(prev => ({ ...prev, accountName: false }));
    }
};

  const validateEmail = async (email) => {
    if (!email) return;

    try {
        const result = await checkEmailApi(email);
        if (!result.status) {
            setValidationErrors(prev => ({
                ...prev,
                email: result.message || 'Email already registered'
            }));
            setValidationMessages(prev => ({
                ...prev,
                email: result.message
            }));
        } else {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.email;
                return newErrors;
            });
            setValidationMessages(prev => ({
                ...prev,
                email: result.message || 'Email is available'
            }));
        }
    } catch (error) {
        console.error('Email validation error:', error);
        setValidationMessages(prev => ({
            ...prev,
            email: 'Error checking email availability'
        }));
    } finally {
        setIsValidating(prev => ({ ...prev, email: false }));
    }
};

  const validateSponsor = async (sponsorId) => {
    if (!sponsorId || sponsorId.length !== 10) return;

    try {
        const result = await checkUserCodeApi(sponsorId);
        if (!result.status) {
            setValidationErrors(prev => ({
                ...prev,
                sponsorId: result.message || 'Invalid sponsor ID'
            }));
            setSponsorInfo(null);
        } else {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.sponsorId;
                return newErrors;
            });
            if (result.data && result.data.account_name) {
                setSponsorInfo({
                    accountName: result.data.account_name
                });
            } else {
                setSponsorInfo(null);
            }
        }
    } catch (error) {
        console.error('Sponsor validation error:', error);
        setSponsorInfo(null);
    } finally {
        setIsValidating(prev => ({ ...prev, sponsorId: false }));
    }
};

  const validatePlacement = async (placementId) => {
    if (!placementId || placementId.length !== 10) return;

    try {
      const result = await checkUserCode(placementId);
      if (!result.status) {
        setValidationErrors(prev => ({
          ...prev,
          placementId: result.message || 'Invalid placement ID'
        }));
        setPlacementInfo(null);
      } else {
        setValidationErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors.placementId;
          return newErrors;
        });
        if (result.data && result.data.account_name) {
          setPlacementInfo({
            accountName: result.data.account_name
          });
        } else {
          setPlacementInfo(null);
        }
      }
    } catch (error) {
      console.error('Placement validation error:', error);
      setPlacementInfo(null);
    } finally {
      setIsValidating(prev => ({ ...prev, placementId: false }));
    }
  };

  const resetRecaptcha = () => {
    console.log('🔄 Resetting reCAPTCHA...');
    
    if (window.grecaptcha && recaptchaRef.current) {
      const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
      if (widgetId && widgetId !== 'null') {
        try {
          window.grecaptcha.reset(parseInt(widgetId));
          console.log('✅ reCAPTCHA reset successfully');
        } catch (error) {
          console.log('⚠️ Could not reset reCAPTCHA:', error);
        }
      }
    }
    
    setRecaptchaToken("");
    setPendingFormData(null);
    pendingFormDataRef.current = null;
    
    setTimeout(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        initializeRecaptcha();
      }
    }, 500);
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      otpRefs.current[index + 1].current.focus();
    }

    if (index === 5 && value && newOtp.every(digit => digit !== "")) {
      const fullOtp = newOtp.join('');
      verifyOtp(fullOtp);
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        otpRefs.current[index - 1].current.focus();
      }
    }
  };

  const createFormUrlEncoded = (data) => {
    const formBody = [];
    for (const property in data) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    return formBody.join("&");
  };

  const checkUsername = async (accountName) => {
    try {
      const formBody = createFormUrlEncoded({
        account_name: accountName
      });

      const response = await fetch('https://global.thewillowquantum.com/api/check-username', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });
      return await response.json();
    } catch (error) {
      console.error('Check username error:', error);
      return { status: false, message: 'Error checking username' };
    }
  };

  const checkEmail = async (email) => {
    try {
      const formBody = createFormUrlEncoded({
        email: email
      });

      const response = await fetch('https://global.thewillowquantum.com/api/check-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });
      return await response.json();
    } catch (error) {
      console.error('Check email error:', error);
      return { status: false, message: 'Error checking email' };
    }
  };

const checkMobile = async (nationalNumber, countryName, countryCode) => {
  try {
    console.log('checkMobile API call with:', {
      mobile_number: nationalNumber,
      country_name: countryName,
      country_code: countryCode
    });

    const formBody = createFormUrlEncoded({
      mobile_number: nationalNumber || "",
      country_name: countryName || "",
      country_code: countryCode || ""
    });

    console.log('Form body for check-mobile:', formBody);

    const response = await fetch('https://global.thewillowquantum.com/api/check-mobile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formBody
    });

    const result = await response.json();
    console.log('checkMobile API response:', result);
    return result;

  } catch (error) {
    console.error('Check mobile error:', error);
    return { status: false, message: 'Error checking mobile number' };
  }
};

const validateMobile = async (nationalNumber, countryName, countryCode) => {
    if (!nationalNumber) return;

    try {
        const result = await checkMobileApi(nationalNumber, countryName, countryCode);

        if (!result.status) {
            setValidationErrors(prev => ({
                ...prev,
                mobileNumber: result.message || 'Mobile number already registered'
            }));
            setValidationMessages(prev => ({
                ...prev,
                mobileNumber: result.message
            }));
        } else {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.mobileNumber;
                return newErrors;
            });
            setValidationMessages(prev => ({
                ...prev,
                mobileNumber: result.message || 'Mobile number is available'
            }));
        }
    } catch (error) {
        console.error('Mobile validation error:', error);
        setValidationMessages(prev => ({
            ...prev,
            mobileNumber: 'Error checking mobile number availability'
        }));
    } finally {
        setIsValidating(prev => ({ ...prev, mobileNumber: false }));
    }
};

const handlePhoneChange = (phoneNumber, phoneData) => {
  console.log("phoneNumber : ", phoneNumber);
  console.log("country data : ", phoneData);

  // FIX: Extract from phoneData.country object (not root level)
  const countryInfo = phoneData?.country || {};
  const dialCode = countryInfo.dialCode || "91";
  const countryCode = countryInfo.iso2?.toLowerCase() || "in";
  const countryName = countryInfo.name || "India";

  console.log("dialCode:", dialCode);
  console.log("countryCode:", countryCode);
  console.log("countryName:", countryName);

  // Store the full formatted phone number (with spaces/hyphens for display)
  setPhone(phoneNumber || "");

  let nationalNumber = "";

  if (phoneNumber) {
    // Remove ALL non-digit characters including hyphens, spaces, parentheses, etc.
    const digitsOnly = phoneNumber.replace(/\D/g, "");
    console.log("digitsOnly:", digitsOnly);
    
    // Check if it's only the dial code (like +371 without actual number)
    const dialCodePattern = new RegExp(`^\\+?\\s*${dialCode}\\s*$`);
    const isOnlyDialCode = dialCodePattern.test(phoneNumber.trim());
    console.log("isOnlyDialCode:", isOnlyDialCode);

    if (isOnlyDialCode) {
      nationalNumber = "";
      console.log("Only dial code present");
    } else if (digitsOnly.startsWith(dialCode) && digitsOnly.length > dialCode.length) {
      nationalNumber = digitsOnly.substring(dialCode.length);
      console.log("Removed dialCode, nationalNumber:", nationalNumber);
    } else if (!digitsOnly.startsWith(dialCode)) {
      nationalNumber = digitsOnly;
      console.log("Doesn't start with dialCode, using as national number:", nationalNumber);
    } else {
      nationalNumber = "";
      console.log("Edge case");
    }
  } else {
    nationalNumber = "";
    console.log("No phone number");
  }

  console.log("nationalNumber (clean digits only):", nationalNumber);

  // Update phone country data
  setPhoneCountryData({
    dialCode,
    countryCode,
    countryName,
    nationalNumber: nationalNumber,
    fullFormattedNumber: phoneNumber || "" // Store the formatted number with spaces
  });

  // Clear validation errors and messages
  if (validationErrors.mobileNumber) {
    setValidationErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors.mobileNumber;
      return newErrors;
    });
  }

  if (validationMessages.mobileNumber) {
    setValidationMessages(prev => {
      const newMessages = { ...prev };
      delete newMessages.mobileNumber;
      return newMessages;
    });
  }

  // Validate mobile number if we have a national number
  if (nationalNumber && nationalNumber.length > 0) {
    const requiredDigits = countryCode === 'in' ? 10 : 8;
    
    if (nationalNumber.length >= requiredDigits) {
      console.log(`✅ Valid ${countryName} number (${nationalNumber.length} digits), calling API`);
      setIsValidating(prev => ({ ...prev, mobileNumber: true }));
      
      // Use the dynamically extracted values
      validateMobile(nationalNumber, countryName, `+${dialCode}`);
    } else if (nationalNumber.length > 0 && nationalNumber.length < requiredDigits) {
      console.log(`❌ ${countryName} number too short: ${nationalNumber.length} digits (need ${requiredDigits})`);
      setValidationErrors(prev => ({
        ...prev,
        mobileNumber: `Mobile number must be at least ${requiredDigits} digits for ${countryName}`
      }));
      setIsValidating(prev => ({ ...prev, mobileNumber: false }));
    } else {
      setIsValidating(prev => ({ ...prev, mobileNumber: false }));
    }
  } else {
    setIsValidating(prev => ({ ...prev, mobileNumber: false }));
  }
};

  const checkUserCode = async (userCode) => {
    try {
      const formBody = createFormUrlEncoded({
        user_code: userCode
      });

      const response = await fetch('https://global.thewillowquantum.com/api/check-user-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });
      return await response.json();
    } catch (error) {
      console.error('Check user code error:', error);
      return { status: false, message: 'Error checking user code' };
    }
  };

  const checkPlacementPosition = async (userCode, position) => {
    try {
      const formBody = createFormUrlEncoded({
        user_code: userCode,
        position: position
      });

      const response = await fetch('https://global.thewillowquantum.com/api/check-placement-position', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });
      return await response.json();
    } catch (error) {
      console.error('Check placement position error:', error);
      return { status: false, message: 'Error checking placement position' };
    }
  };

  const validateAllFields = async () => {
  const errors = {};

  if (!formData.firstName || formData.firstName.length < 3) {
    errors.firstName = 'First name must be at least 3 characters';
  } else if (formData.firstName.length > 25) {
    errors.firstName = 'First name cannot exceed 25 characters';
  }

  if (!formData.lastName || formData.lastName.length < 3) {
    errors.lastName = 'Last name must be at least 3 characters';
  } else if (formData.lastName.length > 25) {
    errors.lastName = 'Last name cannot exceed 25 characters';
  }

  if (!formData.accountName) {
    errors.accountName = 'Account name is required';
  } else if (formData.accountName.length < 6) {
    errors.accountName = 'Account name must be at least 6 characters';
  } else if (formData.accountName.length > 25) {
    errors.accountName = 'Account name cannot exceed 25 characters';
  }

  if (!phoneCountryData.nationalNumber || phoneCountryData.nationalNumber.length === 0) {
    errors.mobileNumber = 'Mobile number is required';
  } else if (phoneCountryData.countryCode === 'in') {
    if (phoneCountryData.nationalNumber.length !== 10) {
      errors.mobileNumber = 'Mobile number must be 10 digits for India';
    }
  } else {
    if (phoneCountryData.nationalNumber.length < 8) {
      errors.mobileNumber = 'Mobile number must be at least 8 digits';
    }
  }

  if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (!formData.sponsorId || formData.sponsorId.length !== 10) {
    errors.sponsorId = 'Sponsor ID must be exactly 10 characters';
  }

  if (!formData.placementId || formData.placementId.length !== 10) {
    errors.placementId = 'Placement ID must be exactly 10 characters';
  }

  if (positionAvailability && !positionAvailability.available) {
    errors.position = positionAvailability.message;
  }

  if (Object.keys(errors).length > 0) {
    setValidationErrors(errors);
    return false;
  }

  if (Object.keys(validationErrors).length > 0) {
    return false;
  }

  return true;
};

  const handleSendOtp = async (data) => {
    try {
        if (!data || !data.email) {
            toast.error("Email data is missing. Please try again.");
            setIsSubmitting(false);
            resetRecaptcha();
            return;
        }

        const fullName = `${data.firstName} ${data.lastName}`;

        const result = await sendEmailOtpApi(data.email, fullName);

        if (result.status) {
            setCurrentStep(2);
            toast.success("OTP has been sent to your email");
        } else {
            toast.error(result.message || "Failed to send OTP. Please try again.");
        }
    } catch (error) {
        console.error("Send OTP error:", error);
        toast.error("An error occurred while sending OTP. Please try again.");
    } finally {
        setIsSubmitting(false);
        resetRecaptcha();
    }
};

  const verifyOtp = async (otpValue) => {
    try {
        setIsSubmitting(true);

        const result = await verifyEmailOtpApi(formData.email, otpValue);

        if (result.status) {
             await handleRegistration();
            // navigate("/registration-payment")
        } else {
            toast.error(result.message || 'Invalid OTP. Please try again.');
            setIsSubmitting(false);
            setOtp(["", "", "", "", "", ""]);
            if (otpRefs.current[0].current) {
                otpRefs.current[0].current.focus();
            }
        }
    } catch (error) {
        console.error('OTP verification error:', error);
        toast.error('An error occurred during OTP verification. Please try again.');
        setIsSubmitting(false);
    }
};

  const handleRegistration = async () => {
    try {
        const registrationData = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            account_name: formData.accountName,
            mobile_number: phoneCountryData.nationalNumber,
            email: formData.email,
            sponsor_code: formData.sponsorId,
            placement_code: formData.placementId,
            position: formData.position,
            country_name: phoneCountryData.countryName,
            country_code: `+${phoneCountryData.dialCode}`
        };

        console.log('Sending registration data:', registrationData);

        const result = await registerApi(registrationData);

        if (result.status) {
            toast.success('Registration completed successfully! Login credentials have been sent to your email.');
            navigate('/signin');
        } else {
            toast.error(result.message || 'Registration failed. Please try again.');
            setIsSubmitting(false);
        }
    } catch (error) {
        console.error('Registration error:', error);
        toast.error('An error occurred during registration. Please try again.');
        setIsSubmitting(false);
    }
};

  const executeRecaptcha = (data) => {
    console.log('🔐 Executing reCAPTCHA...');
    
    pendingFormDataRef.current = data;
    
    if (!window.grecaptcha) {
      console.error("❌ grecaptcha not loaded");
      toast.error("Security verification is still loading. Please wait and try again.");
      setIsSubmitting(false);
      return;
    }
    
    if (!recaptchaRef.current) {
      console.error("❌ recaptchaRef.current is null");
      toast.error("Security verification error. Please refresh the page.");
      setIsSubmitting(false);
      return;
    }
    
    const widgetId = recaptchaRef.current.getAttribute('data-widget-id');
    
    if (!widgetId || widgetId === 'null') {
      console.error("❌ No valid widget ID found. Initializing...");
      
      initializeRecaptcha();
      
      setTimeout(() => {
        const newWidgetId = recaptchaRef.current?.getAttribute('data-widget-id');
        if (newWidgetId && newWidgetId !== 'null') {
          console.log('🔄 Retrying with new widget ID:', newWidgetId);
          try {
            window.grecaptcha.execute(parseInt(newWidgetId));
          } catch (error) {
            console.error('Error executing reCAPTCHA after retry:', error);
            setIsSubmitting(false);
            toast.error('Security verification failed. Please try again.');
          }
        } else {
          console.error('Failed to create widget');
          setIsSubmitting(false);
          toast.error('Security verification failed to initialize. Please refresh.');
        }
      }, 1000);
    } else {
      try {
        console.log('✅ Executing widget with ID:', widgetId);
        window.grecaptcha.execute(parseInt(widgetId));
      } catch (error) {
        console.error('❌ Error executing reCAPTCHA:', error);
        setIsSubmitting(false);
        toast.error('Security verification failed. Please refresh and try again.');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      console.log('⚠️ Already submitting, ignoring duplicate submission');
      return;
    }

    if (currentStep === 1) {
      console.log('📝 Step 1: Validating form...');
      setIsSubmitting(true);
      
      const isValid = await validateAllFields();
      
      if (!isValid) {
        console.log('❌ Validation failed');
        setIsSubmitting(false);
        return;
      }

      console.log('✅ Validation passed');

      if (!isRecaptchaReady) {
        console.log('⏳ reCAPTCHA not ready yet');
        
        toast.info("Initializing security verification... Please wait a moment.");
        
        if (!recaptchaLoaded) {
          loadRecaptchaScript();
        } else if (!recaptchaRef.current.hasAttribute('data-widget-id')) {
          initializeRecaptcha();
        }
        
        setTimeout(() => {
          if (isRecaptchaReady) {
            executeRecaptcha(formData);
          } else {
            setIsSubmitting(false);
            toast.warning("Security verification is taking longer than expected. Please try submitting again.");
          }
        }, 1500);
        
        return;
      }

      console.log('🔐 Executing reCAPTCHA...');
      executeRecaptcha(formData);
      
    } else {
      console.log('📝 Step 2: Verifying OTP...');
      const fullOtp = otp.join('');
      if (fullOtp.length !== 6) {
        toast.error('Please enter a valid 6-digit OTP');
        return;
      }
      verifyOtp(fullOtp);
    }
  };

const resendOtp = async () => {
    try {
        const fullName = `${formData.firstName} ${formData.lastName}`;

        const result = await sendEmailOtpApi(formData.email, fullName);

        if (result.status) {
            toast.success('OTP has been resent to your email.');
            setOtp(["", "", "", "", "", ""]);
            if (otpRefs.current[0].current) {
                otpRefs.current[0].current.focus();
            }
        } else {
            toast.error(result.message || 'Failed to resend OTP. Please try again.');
        }
    } catch (error) {
        console.error('Resend OTP error:', error);
        toast.error('Failed to resend OTP. Please try again.');
    }
};
  
  return (
    <div className="page_wrapper index_ico">
      <div className="backtotop">
        <a href="#" className="scroll">
          <i className="fa-solid fa-arrow-up"></i>
        </a>
      </div>

      <header className="site_header">
        <div className="nav_wrapper">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-5 d-flex align-items-center">
                <div className="site_logo">
                  <a className="site_link" href="/">
                    <img loading="lazy" src={logo} alt="Logo" />
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-2">
                <nav className="main_menu navbar-box navbar-expand-lg">
                  <div className="main_menu_inner collapse navbar-collapse justify-content-center" id="main_menu_dropdown">
                    <ul className="main_menu_list unordered_list text-uppercase">
                      <li className="active">
                        <a className="nav-link" href="#.">
                          <span className="nav_link_label" data-text="Home">Home</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link scrollspy_btn" href="#.">
                          <span className="nav_link_label" data-text="About Us">About Us</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link scrollspy_btn" href="#.">
                          <span className="nav_link_label" data-text="Services">Services</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link scrollspy_btn" href="#.">
                          <span className="nav_link_label" data-text="Metamask">Metamask</span>
                        </a>
                      </li>
                      <li>
                        <a className="nav-link" href="#.">
                          <span className="nav_link_label" data-text="Contact Us">Contact Us</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="col-lg-3 col-5">
                <ul className="btns_group unordered_list p-0 justify-content-end">
                  <li className="d-lg-none">
                    <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                      <i className="far fa-bars"></i>
                    </button>
                  </li>
                  <li>
                    <a className="ico_btn_outline" href="/signin">
                      <span className="btn_icon">
                        <i className="fa-solid fa-user"></i>
                      </span>
                      <span className="btn_label">Login</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="page_content">
        <section className="register_section section_decoration">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5 position-relative">
                <form className="register_form" onSubmit={handleSubmit}>
                  <h1 className="heading_text text-center">
                    {currentStep === 1 ? 'Create Willow Account' : 'Verify Email'}
                  </h1>
                  <p className="text-center">
                    {currentStep === 1 ? 'Enter your details to register with Willow Quantum' : 'Enter OTP sent to your email'}
                  </p>

                  {currentStep === 1 ? (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="input_title" htmlFor="input_firstName">
                              First Name<sup>*</sup>
                            </label>
                            <input
                              id="input_firstName"
                              className={`form-control ${validationErrors.firstName ? 'is-invalid' : ''}`}
                              type="text"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleInputChange}
                              placeholder="Enter First Name (3-25 letters)"
                              maxLength="25"
                              required
                              disabled={isSubmitting}
                              autoComplete="off"
                            />
                            {validationErrors.firstName && (
                              <div className="invalid-feedback d-block">{validationErrors.firstName}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="input_title" htmlFor="input_lastName">
                              Last Name<sup>*</sup>
                            </label>
                            <input
                              id="input_lastName"
                              className={`form-control ${validationErrors.lastName ? 'is-invalid' : ''}`}
                              type="text"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleInputChange}
                              placeholder="Enter Last Name (3-25 letters)"
                              maxLength="25"
                              required
                              disabled={isSubmitting}
                              autoComplete="off"
                            />
                            {validationErrors.lastName && (
                              <div className="invalid-feedback d-block">{validationErrors.lastName}</div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="input_title" htmlFor="input_accountName">
                          Account Name<sup>*</sup>
                        </label>
                        <input
                          id="input_accountName"
                          className={`form-control ${validationErrors.accountName ? 'is-invalid' : ''} ${validationMessages.accountName && !validationErrors.accountName ? 'is-valid' : ''}`}
                          type="text"
                          name="accountName"
                          value={formData.accountName}
                          onChange={handleInputChange}
                          placeholder="Enter Account Name (6-25 characters)"
                          maxLength="25"
                          required
                          disabled={isSubmitting}
                          autoComplete="off"
                        />
                        {validationErrors.accountName && (
                          <div className="invalid-feedback d-block">{validationErrors.accountName}</div>
                        )}
                        {validationMessages.accountName && !validationErrors.accountName && (
                          <div className="valid-feedback d-block">{validationMessages.accountName}</div>
                        )}
                        {isValidating.accountName && (
                          <small className="form-text text-muted">Checking availability...</small>
                        )}
                      </div>

                      <div className="form-group">
                        <label className="input_title" htmlFor="input_mobileNumber">
                          Mobile Number<sup>*</sup>
                        </label>
                        <div className="phone-input-container">
                          <PhoneInput
                            defaultCountry="in"
                            value={phone}
                            onChange={(phone, country) => handlePhoneChange(phone, country)}
                            placeholder="Enter phone number"
                             disableFormatting={true}
      // Optional: Add these props for more control:
      forceDialCode={false}
                            inputStyle={{
                              backgroundColor: "#fff",
                              color: "#333",
                              width: "100%",
                              padding: "12px",
                              border: validationErrors.mobileNumber ? "1px solid #dc3545" : "1px solid #ced4da",
                              borderRadius: "0.375rem",
                            }}
                            countrySelectorStyleProps={{
                              buttonStyle: {
                                backgroundColor: "#fff",
                                color: "#333",
                                border: validationErrors.mobileNumber ? "1px solid #dc3545" : "1px solid #ced4da",
                                borderRight: "none",
                                borderRadius: "0.375rem 0 0 0.375rem",
                              },
                              dropdownStyle: {
                                backgroundColor: "#fff",
                                color: "#333",
                              },
                            }}
                            disabled={isSubmitting}
                          />
                        </div>
                        {validationErrors.mobileNumber && (
                          <div className="invalid-feedback d-block">{validationErrors.mobileNumber}</div>
                        )}
                        {validationMessages.mobileNumber && !validationErrors.mobileNumber && (
                          <div className="valid-feedback d-block">{validationMessages.mobileNumber}</div>
                        )}
                        {isValidating.mobileNumber && (
                          <small className="form-text text-muted">Checking availability...</small>
                        )}

                      </div>

                      <div className="form-group">
                        <label className="input_title" htmlFor="input_email">
                          Email<sup>*</sup>
                        </label>
                        <input
                          id="input_email"
                          className={`form-control ${validationErrors.email ? 'is-invalid' : ''} ${validationMessages.email && !validationErrors.email ? 'is-valid' : ''}`}
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="Enter Email"
                          required
                          disabled={isSubmitting}
                          autoComplete="off"
                        />
                        {validationErrors.email && (
                          <div className="invalid-feedback d-block">{validationErrors.email}</div>
                        )}
                        {validationMessages.email && !validationErrors.email && (
                          <div className="valid-feedback d-block">{validationMessages.email}</div>
                        )}
                        {isValidating.email && (
                          <small className="form-text text-muted">Checking availability...</small>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="input_title" htmlFor="input_sponsorId">
                              Sponsor ID<sup>*</sup>
                            </label>
                            <input
                              id="input_sponsorId"
                              className={`form-control ${validationErrors.sponsorId ? 'is-invalid' : ''}`}
                              type="text"
                              name="sponsorId"
                              value={formData.sponsorId}
                              onChange={handleInputChange}
                              placeholder="Sponsor ID"
                              maxLength="25"
                              required
                              disabled={isSubmitting}
                              readOnly={location.search.includes('sponsor_code')}
                              autoComplete="off"
                            />
                            {validationErrors.sponsorId && (
                              <div className="invalid-feedback d-block">{validationErrors.sponsorId}</div>
                            )}
                            {isValidating.sponsorId && (
                              <small className="form-text text-muted">Checking sponsor ID...</small>
                            )}
                            {sponsorInfo && sponsorInfo.accountName && (
                              <div className="sponsor-info mt-2 p-2 bg-light rounded">
                                <small className="text-success d-block">
                                  Sponsor: {sponsorInfo.accountName}
                                </small>
                              </div>
                            )}

                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="input_title" htmlFor="input_placementId">
                              Placement ID<sup>*</sup>
                            </label>
                            <input
                              id="input_placementId"
                              className={`form-control ${validationErrors.placementId ? 'is-invalid' : ''}`}
                              type="text"
                              name="placementId"
                              value={formData.placementId}
                              onChange={handleInputChange}
                              placeholder="Placement ID"
                              maxLength="10"
                              required
                              disabled={isSubmitting}
                              readOnly={location.search.includes('placement_code')}
                              autoComplete="off"
                            />
                            {validationErrors.placementId && (
                              <div className="invalid-feedback d-block">{validationErrors.placementId}</div>
                            )}
                            {isValidating.placementId && (
                              <small className="form-text text-muted">Checking placement ID...</small>
                            )}
                            {placementInfo && placementInfo.accountName && (
                              <div className="placement-info mt-2 p-2 bg-light rounded">
                                <small className="text-success d-block">
                                  {placementInfo.accountName}
                                </small>
                              </div>
                            )}

                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="input_title" htmlFor="input_position">
                          Position<sup>*</sup>
                        </label>
                       <div className="position-selector">
  <label className={`position-option ${formData.position === 'Left' ? 'active' : ''}`}>
    <input
      type="radio"
      name="position"
      value="Left"
      checked={formData.position === "Left"} // This should work
      onChange={handlePositionChange}
      disabled={isSubmitting || location.search.includes('position=')}
    />
    <span>Left</span>
  </label>
  <label className={`position-option ${formData.position === 'Right' ? 'active' : ''}`}>
    <input
      type="radio"
      name="position"
      value="Right"
      checked={formData.position === "Right"} // This should work
      onChange={handlePositionChange}
      disabled={isSubmitting || location.search.includes('position=')}
    />
    <span>Right</span>
  </label>
</div>
                        {isCheckingPosition && (
                          <small className="form-text text-muted">Checking position availability...</small>
                        )}
                        {positionAvailability && !isCheckingPosition && (
                          <div className={`position-status mt-2 p-2 rounded ${positionAvailability.available ? 'bg-light text-success' : 'bg-light text-danger'}`}>
                            <small className="d-block">
                              <strong>{positionAvailability.message}</strong>
                            </small>
                          </div>
                        )}

                      </div>

                      <div ref={recaptchaRef} style={{ display: 'none' }} />
                    </>
                  ) : (
                    <div className="form-group">
                      <label className="input_title" htmlFor="input_otp">
                        OTP Verification<sup>*</sup>
                      </label>
                      <div className="otp-container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            ref={otpRefs.current[index]}
                            className={`otp-digit ${digit ? 'filled' : ''} ${isSubmitting ? 'disabled' : ''}`}
                            type="text"
                            value={digit}
                            onChange={(e) => handleOtpChange(index, e.target.value)}
                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                            maxLength="1"
                            disabled={isSubmitting}
                            autoFocus={index === 0}
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                        ))}
                      </div>
                      <p className="text-center mt-2">
                        OTP sent to {formData.email}.
                        <button
                          type="button"
                          className="btn btn-link p-0 ml-1"
                          onClick={resendOtp}
                          disabled={isSubmitting}
                        >
                          Resend OTP
                        </button>
                      </p>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-md-6">
                      <p className="forget_pass text-md-start mb-0">
                        Already registered! <a href="/signin"><u>Login</u></a>
                      </p>
                    </div>
                  </div>

                  <button
                    className="btn"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <span className="btn_label">
                      {isSubmitting ? 'Processing...' :
                        currentStep === 1 ? 'Send OTP' : 'Verify OTP'}
                    </span>
                    <span className="btn_icon">
                      {isSubmitting ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <i className="fa-regular fa-arrow-up-right"></i>
                      )}
                    </span>
                  </button>
                </form>

                <div className="decoration_item shape_flower">
                  <img src={flowerShape} alt="Flower" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="ico_site_footer section_decoration section_shadow_top">
        <div className="decoration_item shape_top">
          <img src={footerShape} alt="Bottom Line Shape" />
        </div>
        <div className="container">
          <ul className="pagelist_block unordered_list justify-content-center text-uppercase">
            <li>
              <a className="scrollspy_btn" href="#.">
                <span className="pagelist_label">Home</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#.">
                <span className="pagelist_label">About Us</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#.">
                <span className="pagelist_label">Services</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#.">
                <span className="pagelist_label">Metamask</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#.">
                <span className="pagelist_label">Team</span>
              </a>
            </li>
            <li>
              <a className="scrollspy_btn" href="#.">
                <span className="pagelist_label">Contact Us</span>
              </a>
            </li>
          </ul>
          <div className="middle_area">
            <div className="column">
              <h3 className="footer_title text-uppercase">Join our social group</h3>
              <ul className="social_block style_2 unordered_list justify-content-center">
                <li>
                  <a href="#!">
                    <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.1817 2.34636C10.5036 3.04236 7.14877 4.48456 2.11879 6.67146C1.30201 6.99576 0.873436 7.31296 0.834656 7.62286C0.768491 8.14806 1.42705 8.35476 2.32148 8.63456C2.44372 8.67336 2.57025 8.71206 2.69969 8.75516C3.58123 9.04066 4.76611 9.37506 5.38149 9.38796C5.9409 9.39946 6.56497 9.16986 7.25381 8.69916C11.9531 5.53206 14.379 3.93206 14.5314 3.89756C14.6393 3.87316 14.7888 3.84166 14.8894 3.93206C14.9901 4.02106 14.9801 4.19036 14.97 4.23626C14.9038 4.51326 12.3241 6.90826 10.9868 8.14806C10.5698 8.53416 10.2749 8.80826 10.2146 8.87136C10.0794 9.01056 9.94141 9.14396 9.80908 9.27176C8.98941 10.0581 8.37683 10.6494 9.84356 11.6137C10.5482 12.0772 11.1119 12.4604 11.6741 12.8421C12.2882 13.2597 12.9008 13.6758 13.6945 14.1953C13.8959 14.3273 14.0886 14.4636 14.2769 14.5971C14.9916 15.1065 15.6343 15.5628 16.4281 15.4911C16.8883 15.448 17.3656 15.0161 17.6072 13.726C18.1781 10.6752 19.3026 4.06836 19.5629 1.34476C19.5788 1.11856 19.5691 0.891358 19.5341 0.667358C19.5132 0.486458 19.425 0.320058 19.2868 0.201058C19.0812 0.0331581 18.7619 -0.002742 18.6182 0.000158001C17.9696 0.011558 16.9746 0.357458 12.1817 2.34636Z" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.7876 14L9.31558 5.8405L9.32498 5.8482L14.2588 0H12.6101L8.59076 4.76L5.39902 0H1.07488L6.18362 7.6179L0.794922 14H2.44366L6.91214 8.7042L10.4635 14H14.7876ZM4.74576 1.2727L12.4234 12.7273H11.1168L3.43295 1.2727H4.74576Z" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    <i className="fa-brands fa-github" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="column">
              <h3 className="footer_title text-uppercase">Subscribe to our newsletter</h3>
              <form className="ico_newsletter_form" action="#">
                <input type="email" name="email" placeholder="Enter your email" />
                <button className="submit_btn" type="submit">Submit</button>
              </form>
            </div>
            <div className="column">
              <h3 className="footer_title text-uppercase">Let's coinpay great together.</h3>
              <a className="ico_creative_btn" href="#!">
                <span className="btn_wrapper">
                  <span className="btn_icon_left">
                    <small className="dot_top" />
                    <small className="dot_bottom" />
                    <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                      <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                      <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                    </svg>
                  </span>
                  <span className="btn_label">Purchase a Token</span>
                  <span className="btn_icon_right">
                    <small className="dot_top" />
                    <small className="dot_bottom" />
                    <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                      <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                      <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                    </svg>
                  </span>
                </span>
              </a>
            </div>
          </div>
          <div className="footer_bottom text-center">
            <p className="copyright_text m-0 text-secondary">Copyright© 2025 Willow Quantum. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Registration;